
// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import './DignitarySuperMin.css';

// const API_URL =
//   process.env.REACT_APP_API_URL || 'https://lsdcnodejs-api.onrender.com';


// const PasswordEyeIcon = ({ visible }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />
//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// const passwordWrapStyle = {
//   position: 'relative',
//   width: '100%',
// };


// const passwordInputStyle = {
//   width: '100%',
//   boxSizing: 'border-box',
//   paddingRight: '48px',
// };


// const passwordEyeButtonStyle = {
//   position: 'absolute',
//   top: '50%',
//   right: '14px',
//   transform: 'translateY(-50%)',
//   width: '32px',
//   minWidth: '32px',
//   height: '32px',
//   minHeight: '32px',
//   padding: 0,
//   margin: 0,
//   display: 'grid',
//   placeItems: 'center',
//   border: 'none',
//   borderRadius: '50%',
//   background: 'transparent',
//   boxShadow: 'none',
//   color: '#c6a15b',
//   cursor: 'pointer',
//   zIndex: 3,
// };


// const initialForm = {
//   fullName: '',
//   email: '',
//   phone: '',
//   title: '',
//   organization: '',
// };

// const normalizeInvitationCode = (value = '') => {
//   const raw = value.trim();

//   if (!raw) return '';

//   // Allows you to paste either:
//   // VIP-xxxxxxxx
//   // OR the complete invitation URL.
//   try {
//     if (
//       raw.startsWith('http://') ||
//       raw.startsWith('https://')
//     ) {
//       const url = new URL(raw);
//       const parts = url.pathname
//         .split('/')
//         .filter(Boolean);

//       const invitationIndex =
//         parts.indexOf('invitation');

//       if (
//         invitationIndex !== -1 &&
//         parts[invitationIndex + 1]
//       ) {
//         return decodeURIComponent(
//           parts[invitationIndex + 1]
//         );
//       }

//       return decodeURIComponent(
//         parts[parts.length - 1] || ''
//       );
//     }
//   } catch {
//     // Fall through and treat the input as a raw code.
//   }

//   // Also handles someone pasting:
//   // /invitation/VIP-xxxxx
//   const inviteMarker = '/invitation/';

//   if (raw.includes(inviteMarker)) {
//     return decodeURIComponent(
//       raw
//         .split(inviteMarker)
//         .pop()
//         .split('?')[0]
//         .split('#')[0]
//         .replace(/\/+$/, '')
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(/\/+$/, '');
// };

// export default function DignitarySuperMin() {
//   const navigate = useNavigate();

//   const [form, setForm] = useState(initialForm);
//   const [adminKey, setAdminKey] = useState('');
//   const [showAdminKey, setShowAdminKey] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const [created, setCreated] = useState(null);
//   const [copiedLink, setCopiedLink] = useState(false);
//   const [copiedCode, setCopiedCode] = useState(false);

//   // Existing VIP invitation access
//   const [invitationCode, setInvitationCode] =
//     useState('');

//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] = useState(false);

//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] = useState('');

//   const handleChange = (event) => {
//     const { name, value } = event.target;

//     setForm((current) => ({
//       ...current,
//       [name]: value,
//     }));

//     if (error) {
//       setError('');
//     }
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();

//     if (!adminKey.trim()) {
//       setError(
//         'Enter your admin access key.'
//       );

//       return;
//     }

//     if (!form.fullName.trim()) {
//       setError(
//         'Dignitary full name is required.'
//       );

//       return;
//     }

//     setLoading(true);
//     setError('');
//     setCreated(null);
//     setCopiedLink(false);
//     setCopiedCode(false);

//     try {
//       const response = await fetch(
//         `${API_URL}/api/birthday/dignitary/create`,
//         {
//           method: 'POST',

//           headers: {
//             'Content-Type':
//               'application/json',

//             'x-admin-key':
//               adminKey.trim(),
//           },

//           body: JSON.stringify({
//             fullName:
//               form.fullName.trim(),

//             email:
//               form.email.trim(),

//             phone:
//               form.phone.trim(),

//             title:
//               form.title.trim(),

//             organization:
//               form.organization.trim(),
//           }),
//         }
//       );

//       const result =
//         await response.json();

//       if (
//         !response.ok ||
//         !result.success
//       ) {
//         throw new Error(
//           result.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       }

//       setCreated(result.data);
//       setForm(initialForm);

//       // Automatically prepare the newly created code
//       // for the "Open Invitation" feature.
//       const newCode =
//         normalizeInvitationCode(
//           result.data?.invitationCode ||
//             result.data?.invitationLink ||
//             ''
//         );

//       if (newCode) {
//         setInvitationCode(newCode);
//       }
//     } catch (err) {
//       setError(
//         err.message ||
//           'Unable to create this dignitary invitation.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmAndOpenInvitation =
//     async (rawCode) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(true);
//       setInvitationLookupError('');

//       try {
//         /**
//          * Confirm that the invitation exists first.
//          *
//          * We do not navigate blindly.
//          */
//         const response = await fetch(
//           `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//             code
//           )}`
//         );

//         const result =
//           await response.json();

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No VIP invitation was found with that code.'
//           );
//         }

//         /**
//          * Invitation confirmed.
//          *
//          * Open the exact same page the VIP sees.
//          */
//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );
//       } catch (err) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };

//   const handleInvitationLookup =
//     async (event) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };

//   const openCreatedInvitation =
//     async () => {
//       const code =
//         normalizeInvitationCode(
//           created?.invitationCode ||
//             created?.invitationLink ||
//             ''
//         );

//       if (!code) {
//         setError(
//           'The invitation was created, but no invitation code was returned.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };

//   const copyTextToClipboard = async (text) => {
//     const value = String(text || '').trim();

//     if (!value) {
//       throw new Error('There is nothing to copy.');
//     }

//     if (
//       navigator.clipboard &&
//       window.isSecureContext
//     ) {
//       await navigator.clipboard.writeText(value);
//       return;
//     }

//     const textarea =
//       document.createElement('textarea');

//     textarea.value = value;
//     textarea.setAttribute('readonly', '');

//     textarea.style.position = 'fixed';
//     textarea.style.left = '-9999px';
//     textarea.style.top = '0';
//     textarea.style.opacity = '0';

//     document.body.appendChild(textarea);

//     textarea.focus();
//     textarea.select();
//     textarea.setSelectionRange(
//       0,
//       textarea.value.length
//     );

//     const copied =
//       document.execCommand('copy');

//     document.body.removeChild(textarea);

//     if (!copied) {
//       throw new Error('Copy failed.');
//     }
//   };


//   const getCreatedInvitationCode = () =>
//     normalizeInvitationCode(
//       created?.invitationCode ||
//         created?.invitationLink ||
//         ''
//     );


//   const getCreatedInvitationLink = () => {
//     const code =
//       getCreatedInvitationCode();

//     if (!code) {
//       return (
//         created?.invitationLink ||
//         ''
//       );
//     }

//     if (
//       typeof window !== 'undefined' &&
//       window.location?.origin
//     ) {
//       return `${window.location.origin}/invitation/${encodeURIComponent(
//         code
//       )}`;
//     }

//     return (
//       created?.invitationLink ||
//       `/invitation/${encodeURIComponent(
//         code
//       )}`
//     );
//   };


//   const copyInvitationLink = async () => {
//     const invitationLink =
//       getCreatedInvitationLink();

//     if (!invitationLink) {
//       setError(
//         'No invitation link is available to copy.'
//       );
//       return;
//     }

//     try {
//       await copyTextToClipboard(
//         invitationLink
//       );

//       setCopiedLink(true);
//       setCopiedCode(false);

//       setTimeout(() => {
//         setCopiedLink(false);
//       }, 2000);
//     } catch (err) {
//       console.error(
//         'Copy invitation link error:',
//         err
//       );

//       setError(
//         'Could not copy the invitation link automatically. Please copy it manually.'
//       );
//     }
//   };


//   const copyInvitationCode = async () => {
//     const code =
//       getCreatedInvitationCode();

//     if (!code) {
//       setError(
//         'No invitation code is available to copy.'
//       );
//       return;
//     }

//     try {
//       await copyTextToClipboard(
//         code
//       );

//       setCopiedCode(true);
//       setCopiedLink(false);

//       setTimeout(() => {
//         setCopiedCode(false);
//       }, 2000);
//     } catch (err) {
//       console.error(
//         'Copy invitation code error:',
//         err
//       );

//       setError(
//         'Could not copy the invitation code automatically. Please copy it manually.'
//       );
//     }
//   };

//   const createAnother = () => {
//     setCreated(null);
//     setCopiedLink(false);
//     setCopiedCode(false);
//     setError('');
//   };

//   return (
//     <div className="dignitary-admin-page">
//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />

//       <motion.main
//         className="dignitary-admin-card"
//         initial={{
//           opacity: 0,
//           y: 24,
//         }}
//         animate={{
//           opacity: 1,
//           y: 0,
//         }}
//         transition={{
//           duration: 0.45,
//         }}
//       >
//         <div className="dignitary-admin-lock">
//           VIP
//         </div>

//         <span className="dignitary-admin-eyebrow">
//           Private
//         </span>

//         <h1>
//           Create VIP Invitation
//         </h1>

//         <p className="dignitary-admin-intro">
//           Create a private invitation for a VIP.
//         </p>


//         {/* =========================================
//             OPEN EXISTING VIP INVITATION
//         ========================================= */}

//         <section className="dignitary-invite-access">
//           <div className="dignitary-invite-access-heading">
//             <span className="dignitary-invite-access-icon">
//               ✦
//             </span>

//             <div>
//               <strong>
//                 Open Existing VIP Invitation
//               </strong>

//               <small>
//                 Enter the invitation code to confirm and
//                 preview the exact invitation page.
//               </small>
//             </div>
//           </div>

//           <form
//             className="dignitary-invite-access-form"
//             onSubmit={
//               handleInvitationLookup
//             }
//           >
//             <label htmlFor="vip-invitation-code">
//               Invitation Code
//             </label>

//             <div className="dignitary-invite-access-row">
//               <input
//                 id="vip-invitation-code"
//                 type="text"
//                 value={invitationCode}
//                 onChange={(event) => {
//                   setInvitationCode(
//                     event.target.value
//                   );

//                   if (
//                     invitationLookupError
//                   ) {
//                     setInvitationLookupError(
//                       ''
//                     );
//                   }
//                 }}
//                 placeholder="VIP-xxxxxxxx or paste the full invitation link"
//                 autoComplete="off"
//               />

//               <button
//                 type="submit"
//                 disabled={
//                   invitationLookupLoading
//                 }
//               >
//                 {invitationLookupLoading
//                   ? 'Confirming…'
//                   : 'Confirm & View'}
//               </button>
//             </div>

//             {invitationLookupError && (
//               <div
//                 className="dignitary-invite-access-error"
//                 role="alert"
//               >
//                 {invitationLookupError}
//               </div>
//             )}

//             <p>
//               You can paste either the invitation code or the
//               complete invitation link.
//             </p>
//           </form>
//         </section>


//         <div className="dignitary-admin-divider dignitary-admin-divider--major">
//           <span />
//           <b>
//             CREATE NEW VIP
//           </b>
//           <span />
//         </div>


//         {error && (
//           <div
//             className="dignitary-admin-alert"
//             role="alert"
//           >
//             {error}
//           </div>
//         )}


//         {created ? (
//           <motion.section
//             className="dignitary-created"
//             initial={{
//               opacity: 0,
//               scale: 0.98,
//             }}
//             animate={{
//               opacity: 1,
//               scale: 1,
//             }}
//           >
//             <div className="dignitary-created-check">
//               ✓
//             </div>

//             <span className="dignitary-created-label">
//               Invitation Created
//             </span>

//             <h2>
//               {created.fullName}
//             </h2>

//             {(
//               created.title ||
//               created.organization
//             ) && (
//               <p>
//                 {[
//                   created.title,
//                   created.organization,
//                 ]
//                   .filter(Boolean)
//                   .join(' · ')}
//               </p>
//             )}


//             {/* INVITATION CODE */}

//             {(created.invitationCode ||
//               created.invitationLink) && (
//               <div className="dignitary-created-code">
//                 <span>
//                   Invitation Code
//                 </span>

//                 <strong>
//                   {getCreatedInvitationCode()}
//                 </strong>

//                 <button
//                   type="button"
//                   className="dignitary-copy-code-button"
//                   onClick={copyInvitationCode}
//                 >
//                   {copiedCode
//                     ? 'Code Copied ✓'
//                     : 'Copy Invitation Code'}
//                 </button>
//               </div>
//             )}


//             <div className="dignitary-access-box">
//               <span>
//                 ACCESS
//               </span>

//               <strong>
//                 ✓ Thanksgiving Service
//               </strong>

//               <strong>
//                 ✓ Reception / Banquet
//               </strong>
//             </div>


//             <div className="dignitary-link-box">
//               <span>
//                 Private Invitation Link
//               </span>

//               <input
//                 type="text"
//                 value={
//                   getCreatedInvitationLink()
//                 }
//                 readOnly
//               />

//               <div className="dignitary-created-actions">
//                 <button
//                   type="button"
//                   onClick={
//                     copyInvitationLink
//                   }
//                 >
//                   {copiedLink
//                     ? 'Link Copied ✓'
//                     : 'Copy Invitation Link'}
//                 </button>

//                 <button
//                   type="button"
//                   className="dignitary-view-button"
//                   onClick={
//                     openCreatedInvitation
//                   }
//                   disabled={
//                     invitationLookupLoading
//                   }
//                 >
//                   View VIP Invitation
//                 </button>
//               </div>
//             </div>


//             <p className="dignitary-private-note">
//               Send the private link directly to the
//               dignitary. The VIP invitation route does not
//               need to appear in your website navigation.
//             </p>


//             <button
//               type="button"
//               className="dignitary-secondary-button"
//               onClick={
//                 createAnother
//               }
//             >
//               Create Another Invitation
//             </button>
//           </motion.section>
//         ) : (
//           <form
//             className="dignitary-admin-form"
//             onSubmit={handleSubmit}
//           >
//             <div className="dignitary-admin-field dignitary-admin-field--secret">
//               <label htmlFor="dignitary-admin-key">
//                 Admin Access Key
//               </label>

//               <div style={passwordWrapStyle}>
//                 <input
//                   id="dignitary-admin-key"
//                   type={
//                     showAdminKey
//                       ? 'text'
//                       : 'password'
//                   }
//                   value={adminKey}
//                   onChange={(event) => {
//                     setAdminKey(
//                       event.target.value
//                     );

//                     if (error) {
//                       setError('');
//                     }
//                   }}
//                   placeholder="Enter your private admin key"
//                   autoComplete="off"
//                   required
//                   style={passwordInputStyle}
//                 />

//                 <button
//                   type="button"
//                   onClick={() =>
//                     setShowAdminKey(
//                       (current) => !current
//                     )
//                   }
//                   aria-label={
//                     showAdminKey
//                       ? 'Hide admin access key'
//                       : 'Show admin access key'
//                   }
//                   title={
//                     showAdminKey
//                       ? 'Hide password'
//                       : 'Show password'
//                   }
//                   style={passwordEyeButtonStyle}
//                 >
//                   <PasswordEyeIcon
//                     visible={showAdminKey}
//                   />
//                 </button>
//               </div>

//               <small>
//                 The key is used only when creating the VIP
//                 invitation.
//               </small>
//             </div>


//             <div className="dignitary-admin-divider">
//               <span />
//               <b>
//                 VIP DETAILS
//               </b>
//               <span />
//             </div>


//             <div className="dignitary-admin-field">
//               <label htmlFor="dignitary-full-name">
//                 Full Name
//               </label>

//               <input
//                 id="dignitary-full-name"
//                 name="fullName"
//                 type="text"
//                 value={form.fullName}
//                 onChange={
//                   handleChange
//                 }
//                 placeholder="e.g. Esteemed Pastor Jane Doe"
//                 required
//               />
//             </div>


//             <div className="dignitary-admin-grid">
//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-title">
//                   Title
//                 </label>

//                 <input
//                   id="dignitary-title"
//                   name="title"
//                   type="text"
//                   value={form.title}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="e.g. Esteemed Pastor"
//                 />
//               </div> */}

//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-organization">
//                   Ministry / Zone
//                 </label>

//                 <input
//                   id="dignitary-organization"
//                   name="organization"
//                   type="text"
//                   value={
//                     form.organization
//                   }
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="e.g. Loveworld"
//                 />
//               </div> */}
//             </div>


//             <div className="dignitary-admin-grid">
//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-email">
//                   Email
//                 </label>

//                 <input
//                   id="dignitary-email"
//                   name="email"
//                   type="email"
//                   value={form.email}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="Optional"
//                   autoComplete="email"
//                 />
//               </div> */}

//               {/* <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-phone">
//                   Phone
//                 </label>

//                 <input
//                   id="dignitary-phone"
//                   name="phone"
//                   type="tel"
//                   value={form.phone}
//                   onChange={
//                     handleChange
//                   }
//                   placeholder="Optional"
//                   autoComplete="tel"
//                 />
//               </div> */}
//             </div>


//             <motion.button
//               type="submit"
//               className="dignitary-admin-submit"
//               disabled={loading}
//               whileHover={
//                 !loading
//                   ? {
//                       scale: 1.01,
//                     }
//                   : {}
//               }
//               whileTap={
//                 !loading
//                   ? {
//                       scale: 0.99,
//                     }
//                   : {}
//               }
//             >
//               {loading
//                 ? 'Creating Invitation…'
//                 : 'Create Private Invitation'}
//             </motion.button>
//           </form>
//         )}
//       </motion.main>
//     </div>
//   );
// }

//Open Existing Invitation

// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   motion,
// } from 'framer-motion';

// import {
//   useNavigate,
// } from 'react-router-dom';

// import * as XLSX
//   from 'xlsx';

// import './DignitarySuperMin.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// const initialForm = {
//   fullName: '',
//   dignitaryLevel: 'VIP',
// };
// //View Inv

// /* ==========================================
//    PASSWORD EYE
// ========================================== */

// const PasswordEyeIcon = ({
//   visible,
// }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />

//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />

//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />

//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// /* ==========================================
//    HELPERS
// ========================================== */

// const normalizeInvitationCode = (
//   value = ''
// ) => {
//   const raw =
//     String(value || '')
//       .trim();

//   if (!raw) {
//     return '';
//   }

//   try {
//     if (
//       raw.startsWith(
//         'http://'
//       ) ||
//       raw.startsWith(
//         'https://'
//       )
//     ) {
//       const url =
//         new URL(raw);

//       const parts =
//         url.pathname
//           .split('/')
//           .filter(Boolean);

//       const invitationIndex =
//         parts.findIndex(
//           (part) =>
//             part.toLowerCase() ===
//             'invitation'
//         );

//       if (
//         invitationIndex !== -1 &&
//         parts[
//           invitationIndex + 1
//         ]
//       ) {
//         return decodeURIComponent(
//           parts[
//             invitationIndex + 1
//           ]
//         );
//       }

//       return decodeURIComponent(
//         parts[
//           parts.length - 1
//         ] || ''
//       );
//     }
//   } catch {
//     // Treat as raw invitation code.
//   }

//   const marker =
//     '/invitation/';

//   const lowerRaw =
//     raw.toLowerCase();

//   const markerIndex =
//     lowerRaw.indexOf(
//       marker
//     );

//   if (
//     markerIndex !== -1
//   ) {
//     return decodeURIComponent(
//       raw
//         .slice(
//           markerIndex +
//             marker.length
//         )
//         .split('?')[0]
//         .split('#')[0]
//         .replace(
//           /\/+$/,
//           ''
//         )
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(
//       /\/+$/,
//       ''
//     );
// };


// const copyTextToClipboard =
//   async (text) => {
//     const value =
//       String(
//         text || ''
//       ).trim();

//     if (!value) {
//       throw new Error(
//         'There is nothing to copy.'
//       );
//     }

//     if (
//       navigator.clipboard &&
//       window.isSecureContext
//     ) {
//       await navigator.clipboard.writeText(
//         value
//       );

//       return;
//     }

//     const textarea =
//       document.createElement(
//         'textarea'
//       );

//     textarea.value =
//       value;

//     textarea.setAttribute(
//       'readonly',
//       ''
//     );

//     textarea.style.position =
//       'fixed';

//     textarea.style.left =
//       '-9999px';

//     textarea.style.opacity =
//       '0';

//     document.body.appendChild(
//       textarea
//     );

//     textarea.focus();
//     textarea.select();

//     const copied =
//       document.execCommand(
//         'copy'
//       );

//     textarea.remove();

//     if (!copied) {
//       throw new Error(
//         'Copy failed.'
//       );
//     }
//   };


// const buildInvitationLink = (
//   code,
//   fallbackLink = ''
// ) => {
//   const normalizedCode =
//     normalizeInvitationCode(
//       code ||
//         fallbackLink
//     );

//   if (!normalizedCode) {
//     return fallbackLink;
//   }

//   if (
//     typeof window !==
//       'undefined' &&
//     window.location?.origin
//   ) {
//     return `${window.location.origin}/invitation/${encodeURIComponent(
//       normalizedCode
//     )}`;
//   }

//   return fallbackLink;
// };


// const escapeCsv = (
//   value
// ) => {
//   return `"${String(
//     value ?? ''
//   ).replace(
//     /"/g,
//     '""'
//   )}"`;
// };


// /* ==========================================
//    MAIN COMPONENT
// ========================================== */

// export default function DignitarySuperMin() {

//   const navigate =
//     useNavigate();


//   const [
//     activeMode,
//     setActiveMode,
//   ] = useState(
//     'single'
//   );


//   const [
//     adminKey,
//     setAdminKey,
//   ] = useState(
//     () =>
//       sessionStorage.getItem(
//         'birthday_admin_key'
//       ) || ''
//   );


//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] = useState(false);


//   /* ========================================
//      SINGLE INVITATION
//   ======================================== */

//   const [
//     form,
//     setForm,
//   ] = useState(
//     initialForm
//   );


//   const [
//     loading,
//     setLoading,
//   ] = useState(false);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     created,
//     setCreated,
//   ] = useState(null);


//   const [
//     copiedLink,
//     setCopiedLink,
//   ] = useState(false);


//   const [
//     copiedCode,
//     setCopiedCode,
//   ] = useState(false);


//   /* ========================================
//      BULK INVITATION
//   ======================================== */

//   const [
//     bulkFile,
//     setBulkFile,
//   ] = useState(null);


//   const [
//     bulkLoading,
//     setBulkLoading,
//   ] = useState(false);


//   const [
//     bulkError,
//     setBulkError,
//   ] = useState('');


//   const [
//     bulkRowErrors,
//     setBulkRowErrors,
//   ] = useState([]);


//   const [
//     bulkResults,
//     setBulkResults,
//   ] = useState([]);


//   const [
//     copiedBulkKey,
//     setCopiedBulkKey,
//   ] = useState('');


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const [
//     invitationCode,
//     setInvitationCode,
//   ] = useState('');


//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] = useState(false);


//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] = useState('');


//   /* ========================================
//      SUMMARY
//   ======================================== */

//   const bulkSummary =
//     useMemo(
//       () => ({
//         total:
//           bulkResults.length,

//         VIP:
//           bulkResults.filter(
//             (item) =>
//               item.dignitaryLevel ===
//               'VIP'
//           ).length,

//         VVIP:
//           bulkResults.filter(
//             (item) =>
//               item.dignitaryLevel ===
//               'VVIP'
//           ).length,
//       }),
//       [
//         bulkResults,
//       ]
//     );


//   /* ========================================
//      SHARED ADMIN KEY
//   ======================================== */

//   const ensureAdminKey =
//     () => {
//       const key =
//         adminKey.trim();

//       if (!key) {
//         return '';
//       }

//       sessionStorage.setItem(
//         'birthday_admin_key',
//         key
//       );

//       return key;
//     };


//   /* ========================================
//      SINGLE FORM
//   ======================================== */

//   const handleChange =
//     (event) => {
//       const {
//         name,
//         value,
//       } =
//         event.target;

//       setForm(
//         (current) => ({
//           ...current,

//           [name]:
//             value,
//         })
//       );

//       if (error) {
//         setError('');
//       }
//     };


//   const handleSubmit =
//     async (event) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (
//         !form.fullName.trim()
//       ) {
//         setError(
//           'Dignitary full name is required.'
//         );

//         return;
//       }

//       if (
//         ![
//           'VIP',
//           'VVIP',
//         ].includes(
//           form.dignitaryLevel
//         )
//       ) {
//         setError(
//           'Select VIP or VVIP.'
//         );

//         return;
//       }

//       setLoading(true);
//       setError('');
//       setCreated(null);
//       setCopiedLink(false);
//       setCopiedCode(false);

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/dignitary/create`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',

//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 JSON.stringify({
//                   fullName:
//                     form.fullName.trim(),

//                   dignitaryLevel:
//                     form.dignitaryLevel,
//                 }),
//             }
//           );

//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'Unable to create this dignitary invitation.'
//           );
//         }

//         setCreated(
//           result.data
//         );

//         setForm(
//           initialForm
//         );

//         const newCode =
//           normalizeInvitationCode(
//             result.data
//               ?.invitationCode ||
//               result.data
//                 ?.invitationLink ||
//               ''
//           );

//         if (newCode) {
//           setInvitationCode(
//             newCode
//           );
//         }

//       } catch (err) {
//         setError(
//           err.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };


//   const getCreatedInvitationCode =
//     () =>
//       normalizeInvitationCode(
//         created
//           ?.invitationCode ||
//           created
//             ?.invitationLink ||
//           ''
//       );


//   const getCreatedInvitationLink =
//     () =>
//       buildInvitationLink(
//         created
//           ?.invitationCode,
//         created
//           ?.invitationLink ||
//           ''
//       );


//   const copyInvitationLink =
//     async () => {
//       const link =
//         getCreatedInvitationLink();

//       if (!link) {
//         setError(
//           'No invitation link is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           link
//         );

//         setCopiedLink(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedLink(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation link.'
//         );
//       }
//     };


//   const copyInvitationCode =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           code
//         );

//         setCopiedCode(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedCode(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation code.'
//         );
//       }
//     };


//   const createAnother =
//     () => {
//       setCreated(null);
//       setError('');
//       setCopiedCode(false);
//       setCopiedLink(false);
//     };


//   /* ========================================
//      DOWNLOAD TEMPLATE FROM FRONTEND
//   ======================================== */

//   const downloadBulkTemplate =
//     () => {
//       /**
//        * The admin does NOT need a template
//        * stored in /public.
//        *
//        * We generate it instantly in the browser.
//        *
//        * EXACTLY TWO FIELDS:
//        *
//        * Fullname
//        * VIP/VVIP
//        */
//       const worksheet =
//         XLSX.utils.aoa_to_sheet(
//           [
//             [
//               'Fullname',
//               'VIP/VVIP',
//             ],
//           ]
//         );


//       worksheet['!cols'] = [
//         {
//           wch:
//             40,
//         },
//         {
//           wch:
//             18,
//         },
//       ];


//       const workbook =
//         XLSX.utils.book_new();


//       XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         'Dignitary Upload'
//       );


//       XLSX.writeFile(
//         workbook,
//         'COS_Dignitary_Upload_Template.xlsx'
//       );
//     };


//   /* ========================================
//      BULK UPLOAD
//   ======================================== */

//   const handleBulkUpload =
//     async (event) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setBulkError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (!bulkFile) {
//         setBulkError(
//           'Choose the completed Excel file.'
//         );

//         return;
//       }

//       if (
//         !/\.xlsx$/i.test(
//           bulkFile.name
//         )
//       ) {
//         setBulkError(
//           'Only .xlsx Excel files are allowed.'
//         );

//         return;
//       }

//       setBulkLoading(
//         true
//       );

//       setBulkError('');
//       setBulkRowErrors([]);
//       setBulkResults([]);

//       try {
//         const formData =
//           new FormData();

//         formData.append(
//           'file',
//           bulkFile
//         );


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries/bulk-upload`,
//             {
//               method:
//                 'POST',

//               /**
//                * DO NOT manually set
//                * Content-Type here.
//                *
//                * Browser must create the
//                * multipart boundary.
//                */
//               headers: {
//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 formData,
//             }
//           );


//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }


//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           if (
//             Array.isArray(
//               result.errors
//             )
//           ) {
//             setBulkRowErrors(
//               result.errors
//             );
//           }

//           throw new Error(
//             result.message ||
//               'Unable to upload dignitaries.'
//           );
//         }


//         setBulkResults(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );


//         setBulkFile(
//           null
//         );


//         /**
//          * Reset file input element.
//          */
//         const fileInput =
//           document.getElementById(
//             'dignitary-bulk-file'
//           );

//         if (fileInput) {
//           fileInput.value =
//             '';
//         }

//       } catch (err) {
//         setBulkError(
//           err.message ||
//             'Unable to upload dignitaries.'
//         );
//       } finally {
//         setBulkLoading(
//           false
//         );
//       }
//     };


//   const copyBulkValue =
//     async (
//       value,
//       key
//     ) => {
//       try {
//         await copyTextToClipboard(
//           value
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () =>
//             setCopiedBulkKey(
//               ''
//             ),
//           1400
//         );
//       } catch {
//         setBulkError(
//           'Unable to copy automatically.'
//         );
//       }
//     };


//   const downloadBulkResults =
//     () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         return;
//       }

//       const rows = [
//         [
//           'Fullname',
//           'VIP/VVIP',
//           'Invitation Code',
//           'Invitation Link',
//         ],

//         ...bulkResults.map(
//           (item) => [
//             item.fullName,
//             item.dignitaryLevel,
//             item.invitationCode,
//             item.invitationLink,
//           ]
//         ),
//       ];


//       const csv =
//         rows
//           .map(
//             (row) =>
//               row
//                 .map(
//                   escapeCsv
//                 )
//                 .join(',')
//           )
//           .join(
//             '\r\n'
//           );


//       const blob =
//         new Blob(
//           [csv],
//           {
//             type:
//               'text/csv;charset=utf-8;',
//           }
//         );


//       const url =
//         URL.createObjectURL(
//           blob
//         );


//       const anchor =
//         document.createElement(
//           'a'
//         );


//       anchor.href =
//         url;

//       anchor.download =
//         'COS_Dignitary_Invitation_Results.csv';


//       document.body.appendChild(
//         anchor
//       );

//       anchor.click();
//       anchor.remove();

//       URL.revokeObjectURL(
//         url
//       );
//     };


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const confirmAndOpenInvitation =
//     async (
//       rawCode
//     ) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP or VVIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(
//         true
//       );

//       setInvitationLookupError(
//         ''
//       );

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//               code
//             )}`
//           );

//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No invitation was found with that code.'
//           );
//         }

//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );

//       } catch (err) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };


//   const handleInvitationLookup =
//     async (event) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };


//   const openCreatedInvitation =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };


//   /* ========================================
//      RENDER
//   ======================================== */

//   return (
//     <div className="dignitary-admin-page">

//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />

//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />


//       <motion.main
//         className="dignitary-admin-card dignitary-admin-card--wide"
//         initial={{
//           opacity:
//             0,

//           y:
//             24,
//         }}
//         animate={{
//           opacity:
//             1,

//           y:
//             0,
//         }}
//         transition={{
//           duration:
//             0.45,
//         }}
//       >

//         <div className="dignitary-admin-lock">
//           VIP / VVIP
//         </div>


//         <span className="dignitary-admin-eyebrow">
//           Private Admin
//         </span>


//         <h1>
//           Dignitary Invitations
//         </h1>


//         <p className="dignitary-admin-intro">
//           Create a single invitation or upload
//           multiple VIP and VVIP dignitaries at once.
//         </p>


//         {/* =====================================
//             ADMIN KEY
//         ===================================== */}

//         <section className="dignitary-shared-admin">

//           <label htmlFor="dignitary-admin-key">
//             Admin Access Key
//           </label>


//           <div className="dignitary-password-wrap">

//             <input
//               id="dignitary-admin-key"
//               type={
//                 showAdminKey
//                   ? 'text'
//                   : 'password'
//               }
//               value={
//                 adminKey
//               }
//               onChange={(
//                 event
//               ) => {
//                 setAdminKey(
//                   event.target.value
//                 );

//                 setError('');
//                 setBulkError('');
//               }}
//               placeholder="Enter your private admin key"
//               autoComplete="off"
//             />


//             <button
//               type="button"
//               onClick={() =>
//                 setShowAdminKey(
//                   (current) =>
//                     !current
//                 )
//               }
//               aria-label={
//                 showAdminKey
//                   ? 'Hide admin access key'
//                   : 'Show admin access key'
//               }
//             >
//               <PasswordEyeIcon
//                 visible={
//                   showAdminKey
//                 }
//               />
//             </button>

//           </div>

//         </section>


//         {/* =====================================
//             SINGLE / BULK TABS
//         ===================================== */}

//         <div className="dignitary-mode-tabs">

//           <button
//             type="button"
//             className={
//               activeMode ===
//               'single'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'single'
//               );

//               setBulkError('');
//             }}
//           >
//             Single Invitation
//           </button>


//           <button
//             type="button"
//             className={
//               activeMode ===
//               'bulk'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'bulk'
//               );

//               setError('');
//             }}
//           >
//             Bulk Upload
//           </button>

//         </div>


//         {/* =====================================
//             SINGLE CREATE
//         ===================================== */}

//         {activeMode ===
//           'single' && (

//           <section className="dignitary-mode-panel">


//             {error && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {error}
//               </div>
//             )}


//             {created ? (

//               <motion.div
//                 className="dignitary-created"
//                 initial={{
//                   opacity:
//                     0,

//                   scale:
//                     0.98,
//                 }}
//                 animate={{
//                   opacity:
//                     1,

//                   scale:
//                     1,
//                 }}
//               >

//                 <div className="dignitary-created-check">
//                   ✓
//                 </div>


//                 <span className="dignitary-created-label">
//                   Invitation Created
//                 </span>


//                 <div
//                   className={`dignitary-level-pill dignitary-level-pill--${String(
//                     created.dignitaryLevel ||
//                       'VIP'
//                   ).toLowerCase()}`}
//                 >
//                   {
//                     created.dignitaryLevel ||
//                     'VIP'
//                   }
//                   {' · '}
//                   {
//                     (
//                       created.dignitaryLevel ||
//                       'VIP'
//                     ) ===
//                     'VVIP'
//                       ? 'Gold QR'
//                       : 'Purple QR'
//                   }
//                 </div>


//                 <h2>
//                   {
//                     created.fullName
//                   }
//                 </h2>


//                 <div className="dignitary-created-code">

//                   <span>
//                     Invitation Code
//                   </span>

//                   <strong>
//                     {
//                       getCreatedInvitationCode()
//                     }
//                   </strong>

//                   <button
//                     type="button"
//                     className="dignitary-copy-code-button"
//                     onClick={
//                       copyInvitationCode
//                     }
//                   >
//                     {copiedCode
//                       ? 'Code Copied ✓'
//                       : 'Copy Invitation Code'}
//                   </button>

//                 </div>


//                 <div className="dignitary-access-box">

//                   <span>
//                     ACCESS
//                   </span>

//                   <strong>
//                     ✓ Thanksgiving Service
//                   </strong>

//                   <strong>
//                     ✓ Reception / Banquet
//                   </strong>

//                 </div>


//                 <div className="dignitary-link-box">

//                   <span>
//                     Private Invitation Link
//                   </span>

//                   <input
//                     type="text"
//                     value={
//                       getCreatedInvitationLink()
//                     }
//                     readOnly
//                   />


//                   <div className="dignitary-created-actions">

//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationLink
//                       }
//                     >
//                       {copiedLink
//                         ? 'Link Copied ✓'
//                         : 'Copy Invitation Link'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-view-button"
//                       onClick={
//                         openCreatedInvitation
//                       }
//                       disabled={
//                         invitationLookupLoading
//                       }
//                     >
//                       View Invitation
//                     </button>

//                   </div>

//                 </div>


//                 <button
//                   type="button"
//                   className="dignitary-secondary-button"
//                   onClick={
//                     createAnother
//                   }
//                 >
//                   Create Another Invitation
//                 </button>

//               </motion.div>

//             ) : (

//               <form
//                 className="dignitary-admin-form"
//                 onSubmit={
//                   handleSubmit
//                 }
//               >

//                 <div className="dignitary-admin-divider">
//                   <span />

//                   <b>
//                     SINGLE DIGNITARY
//                   </b>

//                   <span />
//                 </div>


//                 <div className="dignitary-admin-field">

//                   <label htmlFor="dignitary-full-name">
//                     Full Name
//                   </label>

//                   <input
//                     id="dignitary-full-name"
//                     name="fullName"
//                     type="text"
//                     value={
//                       form.fullName
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter dignitary full name"
//                     required
//                   />

//                 </div>


//                 <div className="dignitary-admin-field">

//                   <label htmlFor="dignitary-level">
//                     VIP / VVIP
//                   </label>

//                   <select
//                     id="dignitary-level"
//                     name="dignitaryLevel"
//                     value={
//                       form.dignitaryLevel
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     required
//                   >
//                     <option value="VIP">
//                       VIP — Purple QR
//                     </option>

//                     <option value="VVIP">
//                       VVIP — Gold QR
//                     </option>
//                   </select>

//                 </div>


//                 <motion.button
//                   type="submit"
//                   className="dignitary-admin-submit"
//                   disabled={
//                     loading
//                   }
//                   whileHover={
//                     !loading
//                       ? {
//                           scale:
//                             1.01,
//                         }
//                       : {}
//                   }
//                   whileTap={
//                     !loading
//                       ? {
//                           scale:
//                             0.99,
//                         }
//                       : {}
//                   }
//                 >
//                   {loading
//                     ? 'Creating Invitation…'
//                     : 'Create Private Invitation'}
//                 </motion.button>

//               </form>

//             )}

//           </section>
//         )}


//         {/* =====================================
//             BULK UPLOAD
//         ===================================== */}

//         {activeMode ===
//           'bulk' && (

//           <section className="dignitary-mode-panel">


//             <div className="dignitary-bulk-intro">

//               <div>
//                 <span>
//                   EXCEL TEMPLATE
//                 </span>

//                 <h2>
//                   Two fields only
//                 </h2>

//                 <p>
//                   The downloaded Excel template
//                   contains only:
//                   <strong> Fullname </strong>
//                   and
//                   <strong> VIP/VVIP</strong>.
//                 </p>
//               </div>


//               <button
//                 type="button"
//                 className="dignitary-template-button"
//                 onClick={
//                   downloadBulkTemplate
//                 }
//               >
//                 Download Excel Template
//               </button>

//             </div>


//             <div className="dignitary-category-guide">

//               <div className="dignitary-category-guide--vip">
//                 <span>
//                   VIP
//                 </span>

//                 <strong>
//                   Purple QR Code
//                 </strong>
//               </div>


//               <div className="dignitary-category-guide--vvip">
//                 <span>
//                   VVIP
//                 </span>

//                 <strong>
//                   Gold QR Code
//                 </strong>
//               </div>

//             </div>


//             <form
//               className="dignitary-bulk-form"
//               onSubmit={
//                 handleBulkUpload
//               }
//             >

//               <div className="dignitary-admin-field">

//                 <label htmlFor="dignitary-bulk-file">
//                   Upload Completed Excel File
//                 </label>

//                 <input
//                   id="dignitary-bulk-file"
//                   type="file"
//                   accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                   onChange={(
//                     event
//                   ) => {
//                     setBulkFile(
//                       event.target
//                         .files?.[0] ||
//                         null
//                     );

//                     setBulkError('');
//                     setBulkRowErrors([]);
//                   }}
//                   required
//                 />

//                 {bulkFile && (
//                   <small>
//                     Selected: {
//                       bulkFile.name
//                     }
//                   </small>
//                 )}

//               </div>


//               <button
//                 type="submit"
//                 className="dignitary-admin-submit"
//                 disabled={
//                   bulkLoading
//                 }
//               >
//                 {bulkLoading
//                   ? 'Uploading & Creating Invitations…'
//                   : 'Upload & Generate Invitations'}
//               </button>

//             </form>


//             {bulkError && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {bulkError}
//               </div>
//             )}


//             {bulkRowErrors.length >
//               0 && (

//               <div className="dignitary-bulk-row-errors">

//                 <strong>
//                   Fix these rows and upload again:
//                 </strong>

//                 {bulkRowErrors.map(
//                   (
//                     item,
//                     index
//                   ) => (
//                     <p
//                       key={`${item.row}-${index}`}
//                     >
//                       Row {
//                         item.row
//                       }
//                       {item.fullName
//                         ? ` — ${item.fullName}`
//                         : ''}
//                       : {
//                         item.message
//                       }
//                     </p>
//                   )
//                 )}

//               </div>
//             )}


//             {bulkResults.length >
//               0 && (

//               <div className="dignitary-bulk-results">

//                 <div className="dignitary-bulk-results-head">

//                   <div>
//                     <span>
//                       IMPORT COMPLETE
//                     </span>

//                     <h2>
//                       {
//                         bulkSummary.total
//                       } Invitations Created
//                     </h2>
//                   </div>


//                   <button
//                     type="button"
//                     onClick={
//                       downloadBulkResults
//                     }
//                   >
//                     Download Results CSV
//                   </button>

//                 </div>


//                 <div className="dignitary-bulk-stats">

//                   <div>
//                     <span>
//                       Total
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.total
//                       }
//                     </strong>
//                   </div>


//                   <div className="is-vip">
//                     <span>
//                       VIP
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.VIP
//                       }
//                     </strong>
//                   </div>


//                   <div className="is-vvip">
//                     <span>
//                       VVIP
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.VVIP
//                       }
//                     </strong>
//                   </div>

//                 </div>


//                 <div className="dignitary-bulk-table-wrap">

//                   <table className="dignitary-bulk-table">

//                     <thead>
//                       <tr>
//                         <th>
//                           Fullname
//                         </th>

//                         <th>
//                           VIP/VVIP
//                         </th>

//                         <th>
//                           Invitation Code
//                         </th>

//                         <th>
//                           Invitation Link
//                         </th>
//                       </tr>
//                     </thead>


//                     <tbody>

//                       {bulkResults.map(
//                         (
//                           item,
//                           index
//                         ) => {

//                           const codeKey =
//                             `code-${index}`;

//                           const linkKey =
//                             `link-${index}`;

//                           const level =
//                             item.dignitaryLevel ||
//                             'VIP';

//                           return (
//                             <tr
//                               key={
//                                 item.id ||
//                                 item.invitationCode
//                               }
//                             >

//                               <td>
//                                 <strong>
//                                   {
//                                     item.fullName
//                                   }
//                                 </strong>
//                               </td>


//                               <td>
//                                 <span
//                                   className={`dignitary-level-pill dignitary-level-pill--${level.toLowerCase()}`}
//                                 >
//                                   {
//                                     level
//                                   }
//                                 </span>
//                               </td>


//                               <td>
//                                 <code>
//                                   {
//                                     item.invitationCode
//                                   }
//                                 </code>

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       item.invitationCode,
//                                       codeKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   codeKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Code'}
//                                 </button>
//                               </td>


//                               <td>

//                                 <input
//                                   type="text"
//                                   readOnly
//                                   value={
//                                     item.invitationLink
//                                   }
//                                 />

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       item.invitationLink,
//                                       linkKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   linkKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Link'}
//                                 </button>

//                               </td>

//                             </tr>
//                           );
//                         }
//                       )}

//                     </tbody>

//                   </table>

//                 </div>

//               </div>
//             )}

//           </section>
//         )}

//       </motion.main>

//     </div>
//   );
// }


// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   motion,
// } from 'framer-motion';

// import {
//   useNavigate,
// } from 'react-router-dom';

// import * as XLSX
//   from 'xlsx';

// import './DignitarySuperMin.css';
// //Copy Invite

// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// const initialForm = {
//   fullName: '',
//   dignitaryLevel: 'VIP',
// };
// //View Inv

// /* ==========================================
//    PASSWORD EYE
// ========================================== */

// const PasswordEyeIcon = ({
//   visible,
// }) => (
//   visible ? (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 3L21 21"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />

//       <path
//         d="M10.6 10.7A2 2 0 0013.3 13.4"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//       />

//       <path
//         d="M9.9 4.3A10.6 10.6 0 0112 4c5.4 0 9 5.2 9 5.2a14.4 14.4 0 01-3 3.6M6.1 6.1C4.2 7.3 3 9.2 3 9.2S6.6 14.4 12 14.4c1 0 1.9-.2 2.7-.5"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </svg>
//   ) : (
//     <svg
//       width="20"
//       height="20"
//       viewBox="0 0 24 24"
//       fill="none"
//       aria-hidden="true"
//     >
//       <path
//         d="M3 12s3.6-5.2 9-5.2S21 12 21 12s-3.6 5.2-9 5.2S3 12 3 12z"
//         stroke="currentColor"
//         strokeWidth="1.8"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />

//       <circle
//         cx="12"
//         cy="12"
//         r="2.6"
//         stroke="currentColor"
//         strokeWidth="1.8"
//       />
//     </svg>
//   )
// );


// /* ==========================================
//    HELPERS
// ========================================== */

// const normalizeInvitationCode = (
//   value = ''
// ) => {
//   const raw =
//     String(value || '')
//       .trim();

//   if (!raw) {
//     return '';
//   }

//   try {
//     if (
//       raw.startsWith(
//         'http://'
//       ) ||
//       raw.startsWith(
//         'https://'
//       )
//     ) {
//       const url =
//         new URL(raw);

//       const parts =
//         url.pathname
//           .split('/')
//           .filter(Boolean);

//       const invitationIndex =
//         parts.findIndex(
//           (part) =>
//             part.toLowerCase() ===
//             'invitation'
//         );

//       if (
//         invitationIndex !== -1 &&
//         parts[
//           invitationIndex + 1
//         ]
//       ) {
//         return decodeURIComponent(
//           parts[
//             invitationIndex + 1
//           ]
//         );
//       }

//       return decodeURIComponent(
//         parts[
//           parts.length - 1
//         ] || ''
//       );
//     }
//   } catch {
//     // Treat as raw invitation code.
//   }

//   const marker =
//     '/invitation/';

//   const lowerRaw =
//     raw.toLowerCase();

//   const markerIndex =
//     lowerRaw.indexOf(
//       marker
//     );

//   if (
//     markerIndex !== -1
//   ) {
//     return decodeURIComponent(
//       raw
//         .slice(
//           markerIndex +
//             marker.length
//         )
//         .split('?')[0]
//         .split('#')[0]
//         .replace(
//           /\/+$/,
//           ''
//         )
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(
//       /\/+$/,
//       ''
//     );
// };


// const copyTextToClipboard =
//   async (text) => {
//     const value =
//       String(
//         text || ''
//       ).trim();

//     if (!value) {
//       throw new Error(
//         'There is nothing to copy.'
//       );
//     }

//     if (
//       navigator.clipboard &&
//       window.isSecureContext
//     ) {
//       await navigator.clipboard.writeText(
//         value
//       );

//       return;
//     }

//     const textarea =
//       document.createElement(
//         'textarea'
//       );

//     textarea.value =
//       value;

//     textarea.setAttribute(
//       'readonly',
//       ''
//     );

//     textarea.style.position =
//       'fixed';

//     textarea.style.left =
//       '-9999px';

//     textarea.style.opacity =
//       '0';

//     document.body.appendChild(
//       textarea
//     );

//     textarea.focus();
//     textarea.select();

//     const copied =
//       document.execCommand(
//         'copy'
//       );

//     textarea.remove();

//     if (!copied) {
//       throw new Error(
//         'Copy failed.'
//       );
//     }
//   };


// const buildInvitationLink = (
//   code,
//   fallbackLink = ''
// ) => {
//   const normalizedCode =
//     normalizeInvitationCode(
//       code ||
//         fallbackLink
//     );

//   if (!normalizedCode) {
//     return fallbackLink;
//   }

//   if (
//     typeof window !==
//       'undefined' &&
//     window.location?.origin
//   ) {
//     return `${window.location.origin}/invitation/${encodeURIComponent(
//       normalizedCode
//     )}`;
//   }

//   return fallbackLink;
// };


// /*
//  * Builds the personalised message that the admin
//  * can copy and send directly to each VIP/VVIP.
//  *
//  * If the stored name already begins with "Esteemed"
//  * we do not add "Esteemed" a second time.
//  */
// const formatInviteeSalutation = (
//   fullName = ''
// ) => {
//   const name =
//     String(
//       fullName || ''
//     ).trim();

//   if (!name) {
//     return 'Esteemed Guest';
//   }

//   if (
//     /^esteemed\b/i.test(
//       name
//     )
//   ) {
//     return name;
//   }

//   return `Esteemed ${name}`;
// };


// const buildInvitationMessage = ({
//   fullName,
//   invitationLink,
// }) => {
//   const salutationName =
//     formatInviteeSalutation(
//       fullName
//     );

//   const link =
//     String(
//       invitationLink || ''
//     ).trim();

//   return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

// Dear ${salutationName},

// Greetings in the precious Name of our Lord Jesus Christ.

// We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

// *Event Details:*
// *Thanksgiving Service*: Bay 4, 10am prompt

// *Banquet*: The Angel Court, Immediately after the Thanksgiving

// Kindly click the link below to confirm your attendance, so your SEAT NUMBER can be sent to you.

// Link:
// ${link}

// We look forward to warmly welcoming you.

// Kind regards,
// *The Organising Committee*`;
// };


// const escapeCsv = (
//   value
// ) => {
//   return `"${String(
//     value ?? ''
//   ).replace(
//     /"/g,
//     '""'
//   )}"`;
// };


// /* ==========================================
//    MAIN COMPONENT
// ========================================== */

// export default function DignitarySuperMin() {

//   const navigate =
//     useNavigate();


//   const [
//     activeMode,
//     setActiveMode,
//   ] = useState(
//     'single'
//   );


//   const [
//     adminKey,
//     setAdminKey,
//   ] = useState(
//     () =>
//       sessionStorage.getItem(
//         'birthday_admin_key'
//       ) || ''
//   );


//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] = useState(false);


//   /* ========================================
//      SINGLE INVITATION
//   ======================================== */

//   const [
//     form,
//     setForm,
//   ] = useState(
//     initialForm
//   );


//   const [
//     loading,
//     setLoading,
//   ] = useState(false);


//   const [
//     error,
//     setError,
//   ] = useState('');


//   const [
//     created,
//     setCreated,
//   ] = useState(null);


//   const [
//     copiedLink,
//     setCopiedLink,
//   ] = useState(false);


//   const [
//     copiedCode,
//     setCopiedCode,
//   ] = useState(false);


//   const [
//     copiedInvite,
//     setCopiedInvite,
//   ] = useState(false);


//   /* ========================================
//      BULK INVITATION
//   ======================================== */

//   const [
//     bulkFile,
//     setBulkFile,
//   ] = useState(null);


//   const [
//     bulkLoading,
//     setBulkLoading,
//   ] = useState(false);


//   const [
//     bulkError,
//     setBulkError,
//   ] = useState('');


//   const [
//     bulkRowErrors,
//     setBulkRowErrors,
//   ] = useState([]);


//   const [
//     bulkResults,
//     setBulkResults,
//   ] = useState([]);


//   const [
//     copiedBulkKey,
//     setCopiedBulkKey,
//   ] = useState('');


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const [
//     invitationCode,
//     setInvitationCode,
//   ] = useState('');


//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] = useState(false);


//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] = useState('');


//   /* ========================================
//      SUMMARY
//   ======================================== */

//   const bulkSummary =
//     useMemo(
//       () => ({
//         total:
//           bulkResults.length,

//         VIP:
//           bulkResults.filter(
//             (item) =>
//               item.dignitaryLevel ===
//               'VIP'
//           ).length,

//         VVIP:
//           bulkResults.filter(
//             (item) =>
//               item.dignitaryLevel ===
//               'VVIP'
//           ).length,
//       }),
//       [
//         bulkResults,
//       ]
//     );


//   /* ========================================
//      SHARED ADMIN KEY
//   ======================================== */

//   const ensureAdminKey =
//     () => {
//       const key =
//         adminKey.trim();

//       if (!key) {
//         return '';
//       }

//       sessionStorage.setItem(
//         'birthday_admin_key',
//         key
//       );

//       return key;
//     };


//   /* ========================================
//      SINGLE FORM
//   ======================================== */

//   const handleChange =
//     (event) => {
//       const {
//         name,
//         value,
//       } =
//         event.target;

//       setForm(
//         (current) => ({
//           ...current,

//           [name]:
//             value,
//         })
//       );

//       if (error) {
//         setError('');
//       }
//     };


//   const handleSubmit =
//     async (event) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (
//         !form.fullName.trim()
//       ) {
//         setError(
//           'Dignitary full name is required.'
//         );

//         return;
//       }

//       if (
//         ![
//           'VIP',
//           'VVIP',
//         ].includes(
//           form.dignitaryLevel
//         )
//       ) {
//         setError(
//           'Select VIP or VVIP.'
//         );

//         return;
//       }

//       setLoading(true);
//       setError('');
//       setCreated(null);
//       setCopiedLink(false);
//       setCopiedCode(false);
//       setCopiedInvite(false);

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/dignitary/create`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',

//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 JSON.stringify({
//                   fullName:
//                     form.fullName.trim(),

//                   dignitaryLevel:
//                     form.dignitaryLevel,
//                 }),
//             }
//           );

//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'Unable to create this dignitary invitation.'
//           );
//         }

//         setCreated(
//           result.data
//         );

//         setForm(
//           initialForm
//         );

//         const newCode =
//           normalizeInvitationCode(
//             result.data
//               ?.invitationCode ||
//               result.data
//                 ?.invitationLink ||
//               ''
//           );

//         if (newCode) {
//           setInvitationCode(
//             newCode
//           );
//         }

//       } catch (err) {
//         setError(
//           err.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       } finally {
//         setLoading(false);
//       }
//     };


//   const getCreatedInvitationCode =
//     () =>
//       normalizeInvitationCode(
//         created
//           ?.invitationCode ||
//           created
//             ?.invitationLink ||
//           ''
//       );


//   const getCreatedInvitationLink =
//     () =>
//       buildInvitationLink(
//         created
//           ?.invitationCode,
//         created
//           ?.invitationLink ||
//           ''
//       );


//   const getCreatedInvitationMessage =
//     () =>
//       buildInvitationMessage({
//         fullName:
//           created
//             ?.fullName ||
//           '',
//         invitationLink:
//           getCreatedInvitationLink(),
//       });


//   const copyInvitationMessage =
//     async () => {
//       const message =
//         getCreatedInvitationMessage();

//       if (!message) {
//         setError(
//           'No invitation message is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           message
//         );

//         setCopiedInvite(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedInvite(
//               false
//             ),
//           1800
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation message.'
//         );
//       }
//     };


//   const copyInvitationLink =
//     async () => {
//       const link =
//         getCreatedInvitationLink();

//       if (!link) {
//         setError(
//           'No invitation link is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           link
//         );

//         setCopiedLink(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedLink(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation link.'
//         );
//       }
//     };


//   const copyInvitationCode =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           code
//         );

//         setCopiedCode(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedCode(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation code.'
//         );
//       }
//     };


//   const createAnother =
//     () => {
//       setCreated(null);
//       setError('');
//       setCopiedCode(false);
//       setCopiedLink(false);
//       setCopiedInvite(false);
//     };


//   /* ========================================
//      DOWNLOAD TEMPLATE FROM FRONTEND
//   ======================================== */

//   const downloadBulkTemplate =
//     () => {
//       /**
//        * The admin does NOT need a template
//        * stored in /public.
//        *
//        * We generate it instantly in the browser.
//        *
//        * EXACTLY TWO FIELDS:
//        *
//        * Fullname
//        * VIP/VVIP
//        */
//       const worksheet =
//         XLSX.utils.aoa_to_sheet(
//           [
//             [
//               'Fullname',
//               'VIP/VVIP',
//             ],
//           ]
//         );


//       worksheet['!cols'] = [
//         {
//           wch:
//             40,
//         },
//         {
//           wch:
//             18,
//         },
//       ];


//       const workbook =
//         XLSX.utils.book_new();


//       XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         'Dignitary Upload'
//       );


//       XLSX.writeFile(
//         workbook,
//         'COS_Dignitary_Upload_Template.xlsx'
//       );
//     };


//   /* ========================================
//      BULK UPLOAD
//   ======================================== */

//   const handleBulkUpload =
//     async (event) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setBulkError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (!bulkFile) {
//         setBulkError(
//           'Choose the completed Excel file.'
//         );

//         return;
//       }

//       if (
//         !/\.xlsx$/i.test(
//           bulkFile.name
//         )
//       ) {
//         setBulkError(
//           'Only .xlsx Excel files are allowed.'
//         );

//         return;
//       }

//       setBulkLoading(
//         true
//       );

//       setBulkError('');
//       setBulkRowErrors([]);
//       setBulkResults([]);

//       try {
//         const formData =
//           new FormData();

//         formData.append(
//           'file',
//           bulkFile
//         );


//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries/bulk-upload`,
//             {
//               method:
//                 'POST',

//               /**
//                * DO NOT manually set
//                * Content-Type here.
//                *
//                * Browser must create the
//                * multipart boundary.
//                */
//               headers: {
//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 formData,
//             }
//           );


//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }


//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           if (
//             Array.isArray(
//               result.errors
//             )
//           ) {
//             setBulkRowErrors(
//               result.errors
//             );
//           }

//           throw new Error(
//             result.message ||
//               'Unable to upload dignitaries.'
//           );
//         }


//         setBulkResults(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );


//         setBulkFile(
//           null
//         );


//         /**
//          * Reset file input element.
//          */
//         const fileInput =
//           document.getElementById(
//             'dignitary-bulk-file'
//           );

//         if (fileInput) {
//           fileInput.value =
//             '';
//         }

//       } catch (err) {
//         setBulkError(
//           err.message ||
//             'Unable to upload dignitaries.'
//         );
//       } finally {
//         setBulkLoading(
//           false
//         );
//       }
//     };


//   const copyBulkValue =
//     async (
//       value,
//       key
//     ) => {
//       try {
//         await copyTextToClipboard(
//           value
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () =>
//             setCopiedBulkKey(
//               ''
//             ),
//           1400
//         );
//       } catch {
//         setBulkError(
//           'Unable to copy automatically.'
//         );
//       }
//     };


//   const getBulkInvitationLink =
//     (item) =>
//       buildInvitationLink(
//         item
//           ?.invitationCode,
//         item
//           ?.invitationLink ||
//           ''
//       );


//   const getBulkInvitationMessage =
//     (item) =>
//       buildInvitationMessage({
//         fullName:
//           item
//             ?.fullName ||
//           '',
//         invitationLink:
//           getBulkInvitationLink(
//             item
//           ),
//       });


//   const copyAllBulkInvites =
//     async () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         setBulkError(
//           'There are no generated invitations to copy.'
//         );

//         return;
//       }

//       const allMessages =
//         bulkResults
//           .map(
//             (item) =>
//               getBulkInvitationMessage(
//                 item
//               )
//           )
//           .join(
//             '\n\n------------------------------\n\n'
//           );

//       await copyBulkValue(
//         allMessages,
//         'all-invites'
//       );
//     };


//   const downloadBulkResults =
//     () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         return;
//       }

//       const rows = [
//         [
//           'Fullname',
//           'VIP/VVIP',
//           'Invitation Code',
//           'Invitation Link',
//           'Invitation Message',
//         ],

//         ...bulkResults.map(
//           (item) => [
//             item.fullName,
//             item.dignitaryLevel,
//             item.invitationCode,
//             getBulkInvitationLink(
//               item
//             ),
//             getBulkInvitationMessage(
//               item
//             ),
//           ]
//         ),
//       ];


//       const csv =
//         rows
//           .map(
//             (row) =>
//               row
//                 .map(
//                   escapeCsv
//                 )
//                 .join(',')
//           )
//           .join(
//             '\r\n'
//           );


//       const blob =
//         new Blob(
//           [csv],
//           {
//             type:
//               'text/csv;charset=utf-8;',
//           }
//         );


//       const url =
//         URL.createObjectURL(
//           blob
//         );


//       const anchor =
//         document.createElement(
//           'a'
//         );


//       anchor.href =
//         url;

//       anchor.download =
//         'COS_Dignitary_Invitation_Results.csv';


//       document.body.appendChild(
//         anchor
//       );

//       anchor.click();
//       anchor.remove();

//       URL.revokeObjectURL(
//         url
//       );
//     };


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const confirmAndOpenInvitation =
//     async (
//       rawCode
//     ) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP or VVIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(
//         true
//       );

//       setInvitationLookupError(
//         ''
//       );

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//               code
//             )}`
//           );

//         let result = {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result = {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No invitation was found with that code.'
//           );
//         }

//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );

//       } catch (err) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };


//   const handleInvitationLookup =
//     async (event) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };


//   const openCreatedInvitation =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };


//   /* ========================================
//      RENDER
//   ======================================== */

//   return (
//     <div className="dignitary-admin-page">

//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />

//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />


//       <motion.main
//         className="dignitary-admin-card dignitary-admin-card--wide"
//         initial={{
//           opacity:
//             0,

//           y:
//             24,
//         }}
//         animate={{
//           opacity:
//             1,

//           y:
//             0,
//         }}
//         transition={{
//           duration:
//             0.45,
//         }}
//       >

//         <div className="dignitary-admin-lock">
//           VIP / VVIP
//         </div>


//         <span className="dignitary-admin-eyebrow">
//           Private Admin
//         </span>


//         <h1>
//           Dignitary Invitations
//         </h1>


//         <p className="dignitary-admin-intro">
//           Create a single invitation or upload
//           multiple VIP and VVIP dignitaries at once.
//         </p>


//         {/* =====================================
//             ADMIN KEY
//         ===================================== */}

//         <section className="dignitary-shared-admin">

//           <label htmlFor="dignitary-admin-key">
//             Admin Access Key
//           </label>


//           <div className="dignitary-password-wrap">

//             <input
//               id="dignitary-admin-key"
//               type={
//                 showAdminKey
//                   ? 'text'
//                   : 'password'
//               }
//               value={
//                 adminKey
//               }
//               onChange={(
//                 event
//               ) => {
//                 setAdminKey(
//                   event.target.value
//                 );

//                 setError('');
//                 setBulkError('');
//               }}
//               placeholder="Enter your private admin key"
//               autoComplete="off"
//             />


//             <button
//               type="button"
//               onClick={() =>
//                 setShowAdminKey(
//                   (current) =>
//                     !current
//                 )
//               }
//               aria-label={
//                 showAdminKey
//                   ? 'Hide admin access key'
//                   : 'Show admin access key'
//               }
//             >
//               <PasswordEyeIcon
//                 visible={
//                   showAdminKey
//                 }
//               />
//             </button>

//           </div>

//         </section>


//         {/* =====================================
//             SINGLE / BULK TABS
//         ===================================== */}

//         <div className="dignitary-mode-tabs">

//           <button
//             type="button"
//             className={
//               activeMode ===
//               'single'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'single'
//               );

//               setBulkError('');
//             }}
//           >
//             Single Invitation
//           </button>


//           <button
//             type="button"
//             className={
//               activeMode ===
//               'bulk'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'bulk'
//               );

//               setError('');
//             }}
//           >
//             Bulk Upload
//           </button>

//         </div>


//         {/* =====================================
//             SINGLE CREATE
//         ===================================== */}

//         {activeMode ===
//           'single' && (

//           <section className="dignitary-mode-panel">


//             {error && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {error}
//               </div>
//             )}


//             {created ? (

//               <motion.div
//                 className="dignitary-created"
//                 initial={{
//                   opacity:
//                     0,

//                   scale:
//                     0.98,
//                 }}
//                 animate={{
//                   opacity:
//                     1,

//                   scale:
//                     1,
//                 }}
//               >

//                 <div className="dignitary-created-check">
//                   ✓
//                 </div>


//                 <span className="dignitary-created-label">
//                   Invitation Created
//                 </span>


//                 <div
//                   className={`dignitary-level-pill dignitary-level-pill--${String(
//                     created.dignitaryLevel ||
//                       'VIP'
//                   ).toLowerCase()}`}
//                 >
//                   {
//                     created.dignitaryLevel ||
//                     'VIP'
//                   }
//                   {' · '}
//                   {
//                     (
//                       created.dignitaryLevel ||
//                       'VIP'
//                     ) ===
//                     'VVIP'
//                       ? 'Gold QR'
//                       : 'Purple QR'
//                   }
//                 </div>


//                 <h2>
//                   {
//                     created.fullName
//                   }
//                 </h2>


//                 <div className="dignitary-created-code">

//                   <span>
//                     Invitation Code
//                   </span>

//                   <strong>
//                     {
//                       getCreatedInvitationCode()
//                     }
//                   </strong>

//                   <button
//                     type="button"
//                     className="dignitary-copy-code-button"
//                     onClick={
//                       copyInvitationCode
//                     }
//                   >
//                     {copiedCode
//                       ? 'Code Copied ✓'
//                       : 'Copy Invitation Code'}
//                   </button>

//                 </div>


//                 <div className="dignitary-access-box">

//                   <span>
//                     ACCESS
//                   </span>

//                   <strong>
//                     ✓ Thanksgiving Service
//                   </strong>

//                   <strong>
//                     ✓ Reception / Banquet
//                   </strong>

//                 </div>


//                 <div className="dignitary-link-box">

//                   <span>
//                     Private Invitation Link
//                   </span>

//                   <input
//                     type="text"
//                     value={
//                       getCreatedInvitationLink()
//                     }
//                     readOnly
//                   />


//                   <div className="dignitary-created-actions">

//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationLink
//                       }
//                     >
//                       {copiedLink
//                         ? 'Link Copied ✓'
//                         : 'Copy Invitation Link'}
//                     </button>


//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationMessage
//                       }
//                     >
//                       {copiedInvite
//                         ? 'Invite Message Copied ✓'
//                         : 'Copy Invite Message'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-view-button"
//                       onClick={
//                         openCreatedInvitation
//                       }
//                       disabled={
//                         invitationLookupLoading
//                       }
//                     >
//                       View Invitation
//                     </button>

//                   </div>

//                 </div>


//                 <button
//                   type="button"
//                   className="dignitary-secondary-button"
//                   onClick={
//                     createAnother
//                   }
//                 >
//                   Create Another Invitation
//                 </button>

//               </motion.div>

//             ) : (

//               <form
//                 className="dignitary-admin-form"
//                 onSubmit={
//                   handleSubmit
//                 }
//               >

//                 <div className="dignitary-admin-divider">
//                   <span />

//                   <b>
//                     SINGLE DIGNITARY
//                   </b>

//                   <span />
//                 </div>


//                 <div className="dignitary-admin-field">

//                   <label htmlFor="dignitary-full-name">
//                     Full Name
//                   </label>

//                   <input
//                     id="dignitary-full-name"
//                     name="fullName"
//                     type="text"
//                     value={
//                       form.fullName
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter dignitary full name"
//                     required
//                   />

//                 </div>


//                 <div className="dignitary-admin-field">

//                   <label htmlFor="dignitary-level">
//                     VIP / VVIP
//                   </label>

//                   <select
//                     id="dignitary-level"
//                     name="dignitaryLevel"
//                     value={
//                       form.dignitaryLevel
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     required
//                   >
//                     <option value="VIP">
//                       VIP — Purple QR
//                     </option>

//                     <option value="VVIP">
//                       VVIP — Gold QR
//                     </option>
//                   </select>

//                 </div>


//                 <motion.button
//                   type="submit"
//                   className="dignitary-admin-submit"
//                   disabled={
//                     loading
//                   }
//                   whileHover={
//                     !loading
//                       ? {
//                           scale:
//                             1.01,
//                         }
//                       : {}
//                   }
//                   whileTap={
//                     !loading
//                       ? {
//                           scale:
//                             0.99,
//                         }
//                       : {}
//                   }
//                 >
//                   {loading
//                     ? 'Creating Invitation…'
//                     : 'Create Private Invitation'}
//                 </motion.button>

//               </form>

//             )}

//           </section>
//         )}


//         {/* =====================================
//             BULK UPLOAD
//         ===================================== */}

//         {activeMode ===
//           'bulk' && (

//           <section className="dignitary-mode-panel">


//             <div className="dignitary-bulk-intro">

//               <div>
//                 <span>
//                   EXCEL TEMPLATE
//                 </span>

//                 <h2>
//                   Two fields only
//                 </h2>

//                 <p>
//                   The downloaded Excel template
//                   contains only:
//                   <strong> Fullname </strong>
//                   and
//                   <strong> VIP/VVIP</strong>.
//                 </p>
//               </div>


//               <button
//                 type="button"
//                 className="dignitary-template-button"
//                 onClick={
//                   downloadBulkTemplate
//                 }
//               >
//                 Download Excel Template
//               </button>

//             </div>


//             <div className="dignitary-category-guide">

//               <div className="dignitary-category-guide--vip">
//                 <span>
//                   VIP
//                 </span>

//                 <strong>
//                   Purple QR Code
//                 </strong>
//               </div>


//               <div className="dignitary-category-guide--vvip">
//                 <span>
//                   VVIP
//                 </span>

//                 <strong>
//                   Gold QR Code
//                 </strong>
//               </div>

//             </div>


//             <form
//               className="dignitary-bulk-form"
//               onSubmit={
//                 handleBulkUpload
//               }
//             >

//               <div className="dignitary-admin-field">

//                 <label htmlFor="dignitary-bulk-file">
//                   Upload Completed Excel File
//                 </label>

//                 <input
//                   id="dignitary-bulk-file"
//                   type="file"
//                   accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                   onChange={(
//                     event
//                   ) => {
//                     setBulkFile(
//                       event.target
//                         .files?.[0] ||
//                         null
//                     );

//                     setBulkError('');
//                     setBulkRowErrors([]);
//                   }}
//                   required
//                 />

//                 {bulkFile && (
//                   <small>
//                     Selected: {
//                       bulkFile.name
//                     }
//                   </small>
//                 )}

//               </div>


//               <button
//                 type="submit"
//                 className="dignitary-admin-submit"
//                 disabled={
//                   bulkLoading
//                 }
//               >
//                 {bulkLoading
//                   ? 'Uploading & Creating Invitations…'
//                   : 'Upload & Generate Invitations'}
//               </button>

//             </form>


//             {bulkError && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {bulkError}
//               </div>
//             )}


//             {bulkRowErrors.length >
//               0 && (

//               <div className="dignitary-bulk-row-errors">

//                 <strong>
//                   Fix these rows and upload again:
//                 </strong>

//                 {bulkRowErrors.map(
//                   (
//                     item,
//                     index
//                   ) => (
//                     <p
//                       key={`${item.row}-${index}`}
//                     >
//                       Row {
//                         item.row
//                       }
//                       {item.fullName
//                         ? ` — ${item.fullName}`
//                         : ''}
//                       : {
//                         item.message
//                       }
//                     </p>
//                   )
//                 )}

//               </div>
//             )}


//             {bulkResults.length >
//               0 && (

//               <div className="dignitary-bulk-results">

//                 <div className="dignitary-bulk-results-head">

//                   <div>
//                     <span>
//                       IMPORT COMPLETE
//                     </span>

//                     <h2>
//                       {
//                         bulkSummary.total
//                       } Invitations Created
//                     </h2>
//                   </div>


//                   <button
//                     type="button"
//                     onClick={
//                       copyAllBulkInvites
//                     }
//                   >
//                     {copiedBulkKey ===
//                     'all-invites'
//                       ? 'All Invite Messages Copied ✓'
//                       : 'Copy All Invite Messages'}
//                   </button>


//                   <button
//                     type="button"
//                     onClick={
//                       downloadBulkResults
//                     }
//                   >
//                     Download Results CSV
//                   </button>

//                 </div>


//                 <div className="dignitary-bulk-stats">

//                   <div>
//                     <span>
//                       Total
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.total
//                       }
//                     </strong>
//                   </div>


//                   <div className="is-vip">
//                     <span>
//                       VIP
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.VIP
//                       }
//                     </strong>
//                   </div>


//                   <div className="is-vvip">
//                     <span>
//                       VVIP
//                     </span>

//                     <strong>
//                       {
//                         bulkSummary.VVIP
//                       }
//                     </strong>
//                   </div>

//                 </div>


//                 <div className="dignitary-bulk-table-wrap">

//                   <table className="dignitary-bulk-table">

//                     <thead>
//                       <tr>
//                         <th>
//                           Fullname
//                         </th>

//                         <th>
//                           VIP/VVIP
//                         </th>

//                         <th>
//                           Copy Invite
//                         </th>

//                         <th>
//                           Invitation Code
//                         </th>

//                         <th>
//                           Invitation Link
//                         </th>
//                       </tr>
//                     </thead>


//                     <tbody>

//                       {bulkResults.map(
//                         (
//                           item,
//                           index
//                         ) => {

//                           const codeKey =
//                             `code-${index}`;

//                           const linkKey =
//                             `link-${index}`;

//                           const inviteKey =
//                             `invite-${index}`;

//                           const level =
//                             item.dignitaryLevel ||
//                             'VIP';

//                           return (
//                             <tr
//                               key={
//                                 item.id ||
//                                 item.invitationCode
//                               }
//                             >

//                               <td>
//                                 <strong>
//                                   {
//                                     item.fullName
//                                   }
//                                 </strong>
//                               </td>


//                               <td>
//                                 <span
//                                   className={`dignitary-level-pill dignitary-level-pill--${level.toLowerCase()}`}
//                                 >
//                                   {
//                                     level
//                                   }
//                                 </span>
//                               </td>


//                               <td>
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationMessage(
//                                         item
//                                       ),
//                                       inviteKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   inviteKey
//                                     ? 'Invite Copied ✓'
//                                     : 'Copy Invite'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <code>
//                                   {
//                                     item.invitationCode
//                                   }
//                                 </code>

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       item.invitationCode,
//                                       codeKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   codeKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Code'}
//                                 </button>
//                               </td>


//                               <td>

//                                 <input
//                                   type="text"
//                                   readOnly
//                                   value={
//                                     getBulkInvitationLink(
//                                       item
//                                     )
//                                   }
//                                 />

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationLink(
//                                         item
//                                       ),
//                                       linkKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   linkKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Link'}
//                                 </button>

//                               </td>

//                             </tr>
//                           );
//                         }
//                       )}

//                     </tbody>

//                   </table>

//                 </div>

//               </div>
//             )}

//           </section>
//         )}

//       </motion.main>

//     </div>
//   );
// }



// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   motion,
// } from 'framer-motion';

// import {
//   useNavigate,
// } from 'react-router-dom';

// import * as XLSX
//   from 'xlsx';

// import './DignitarySuperMin.css';


// const API_URL =
//   process.env.REACT_APP_API_URL ||
//   'https://lsdcnodejs-api.onrender.com';


// const initialForm = {
//   title: '',
//   firstname: '',
//   lastname: '',
//   kcusername: '',
//   dignitaryLevel: 'VIP',
// };


// /* ==========================================
//    HELPERS
// ========================================== */

// const normalizeInvitationCode = (
//   value = ''
// ) => {
//   const raw =
//     String(
//       value ||
//       ''
//     ).trim();

//   if (!raw) {
//     return '';
//   }

//   try {
//     if (
//       raw.startsWith(
//         'http://'
//       ) ||
//       raw.startsWith(
//         'https://'
//       )
//     ) {
//       const url =
//         new URL(
//           raw
//         );

//       const parts =
//         url.pathname
//           .split('/')
//           .filter(Boolean);

//       const invitationIndex =
//         parts.findIndex(
//           (part) =>
//             part.toLowerCase() ===
//             'invitation'
//         );

//       if (
//         invitationIndex !== -1 &&
//         parts[
//           invitationIndex + 1
//         ]
//       ) {
//         return decodeURIComponent(
//           parts[
//             invitationIndex + 1
//           ]
//         );
//       }

//       return decodeURIComponent(
//         parts[
//           parts.length - 1
//         ] ||
//         ''
//       );
//     }
//   } catch {
//     // Treat it as a raw invitation code.
//   }

//   const marker =
//     '/invitation/';

//   const lowerRaw =
//     raw.toLowerCase();

//   const markerIndex =
//     lowerRaw.indexOf(
//       marker
//     );

//   if (
//     markerIndex !== -1
//   ) {
//     return decodeURIComponent(
//       raw
//         .slice(
//           markerIndex +
//             marker.length
//         )
//         .split('?')[0]
//         .split('#')[0]
//         .replace(
//           /\/+$/,
//           ''
//         )
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(
//       /\/+$/,
//       ''
//     );
// };


// const normalizeKcUsername = (
//   value = ''
// ) =>
//   String(
//     value ||
//     ''
//   )
//     .trim()
//     .replace(
//       /^@+/,
//       ''
//     )
//     .trim()
//     .toLowerCase();


// const buildKingsChatProfileUrl = (
//   kcusername = ''
// ) => {
//   const username =
//     normalizeKcUsername(
//       kcusername
//     );

//   if (!username) {
//     return '';
//   }

//   return `https://kingschat.online/user/${encodeURIComponent(
//     username
//   )}`;
// };


// const copyTextToClipboard =
//   async (
//     text
//   ) => {
//     const value =
//       String(
//         text ||
//         ''
//       ).trim();

//     if (!value) {
//       throw new Error(
//         'There is nothing to copy.'
//       );
//     }

//     if (
//       navigator.clipboard &&
//       window.isSecureContext
//     ) {
//       await navigator.clipboard.writeText(
//         value
//       );

//       return;
//     }

//     const textarea =
//       document.createElement(
//         'textarea'
//       );

//     textarea.value =
//       value;

//     textarea.setAttribute(
//       'readonly',
//       ''
//     );

//     textarea.style.position =
//       'fixed';

//     textarea.style.left =
//       '-9999px';

//     textarea.style.opacity =
//       '0';

//     document.body.appendChild(
//       textarea
//     );

//     textarea.focus();
//     textarea.select();

//     const copied =
//       document.execCommand(
//         'copy'
//       );

//     textarea.remove();

//     if (!copied) {
//       throw new Error(
//         'Copy failed.'
//       );
//     }
//   };


// const buildInvitationLink = (
//   code,
//   fallbackLink = ''
// ) => {
//   const normalizedCode =
//     normalizeInvitationCode(
//       code ||
//       fallbackLink
//     );

//   if (!normalizedCode) {
//     return fallbackLink;
//   }

//   if (
//     typeof window !==
//       'undefined' &&
//     window.location?.origin
//   ) {
//     return `${window.location.origin}/invitation/${encodeURIComponent(
//       normalizedCode
//     )}`;
//   }

//   return fallbackLink;
// };


// const formatInviteeSalutation = (
//   fullName = ''
// ) => {
//   const name =
//     String(
//       fullName ||
//       ''
//     ).trim();

//   if (!name) {
//     return 'Esteemed Guest';
//   }

//   if (
//     /^esteemed\b/i.test(
//       name
//     )
//   ) {
//     return name;
//   }

//   return `Esteemed ${name}`;
// };


// const buildInvitationMessage = ({
//   fullName,
//   invitationLink,
// }) => {
//   const salutationName =
//     formatInviteeSalutation(
//       fullName
//     );

//   const link =
//     String(
//       invitationLink ||
//       ''
//     ).trim();

//   return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

// Dear ${salutationName},

// Greetings in the precious Name of our Lord Jesus Christ.

// We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

// *Event Details:*
// *Thanksgiving Service*: Bay 4, 10am prompt

// *Banquet*: The Angel Court, Immediately after the Thanksgiving

// Kindly click the link below to confirm your attendance, so your TABLE NUMBER can be sent to you.

// Link:
// ${link}

// We look forward to warmly welcoming you.

// Kind regards,
// *The Organising Committee*`;
// };


// const escapeCsv = (
//   value
// ) =>
//   `"${String(
//     value ??
//     ''
//   ).replace(
//     /"/g,
//     '""'
//   )}"`;


// /* ==========================================
//    MAIN COMPONENT
// ========================================== */

// export default function DignitarySuperMin() {
//   const navigate =
//     useNavigate();


//   /* ========================================
//      MAIN MODE
//   ======================================== */

//   const [
//     activeMode,
//     setActiveMode,
//   ] =
//     useState(
//       'single'
//     );


//   /* ========================================
//      ADMIN
//   ======================================== */

//   const [
//     adminKey,
//     setAdminKey,
//   ] =
//     useState(
//       () =>
//         sessionStorage.getItem(
//           'birthday_admin_key'
//         ) ||
//         ''
//     );

//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] =
//     useState(
//       false
//     );


//   /* ========================================
//      SINGLE INVITATION
//   ======================================== */

//   const [
//     form,
//     setForm,
//   ] =
//     useState(
//       initialForm
//     );

//   const [
//     loading,
//     setLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     error,
//     setError,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     created,
//     setCreated,
//   ] =
//     useState(
//       null
//     );

//   const [
//     copiedLink,
//     setCopiedLink,
//   ] =
//     useState(
//       false
//     );

//   const [
//     copiedCode,
//     setCopiedCode,
//   ] =
//     useState(
//       false
//     );

//   const [
//     copiedInvite,
//     setCopiedInvite,
//   ] =
//     useState(
//       false
//     );

//   const [
//     sentInvite,
//     setSentInvite,
//   ] =
//     useState(
//       false
//     );


//   /* ========================================
//      BULK INVITATION
//   ======================================== */

//   const [
//     bulkFile,
//     setBulkFile,
//   ] =
//     useState(
//       null
//     );

//   const [
//     bulkDignitaryLevel,
//     setBulkDignitaryLevel,
//   ] =
//     useState(
//       'VIP'
//     );

//   const [
//     bulkLoading,
//     setBulkLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     bulkError,
//     setBulkError,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     bulkRowErrors,
//     setBulkRowErrors,
//   ] =
//     useState(
//       []
//     );

//   const [
//     bulkResults,
//     setBulkResults,
//   ] =
//     useState(
//       []
//     );

//   const [
//     copiedBulkKey,
//     setCopiedBulkKey,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     sentBulkKey,
//     setSentBulkKey,
//   ] =
//     useState(
//       ''
//     );


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const [
//     invitationCode,
//     setInvitationCode,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] =
//     useState(
//       ''
//     );


//   /* ========================================
//      SUMMARY
//   ======================================== */

//   const bulkSummary =
//     useMemo(
//       () => ({
//         total:
//           bulkResults.length,

//         VIP:
//           bulkResults.filter(
//             (
//               item
//             ) =>
//               item.dignitaryLevel ===
//               'VIP'
//           ).length,

//         VVIP:
//           bulkResults.filter(
//             (
//               item
//             ) =>
//               item.dignitaryLevel ===
//               'VVIP'
//           ).length,
//       }),
//       [
//         bulkResults,
//       ]
//     );


//   /* ========================================
//      ADMIN KEY
//   ======================================== */

//   const ensureAdminKey =
//     () => {
//       const key =
//         adminKey.trim();

//       if (!key) {
//         return '';
//       }

//       sessionStorage.setItem(
//         'birthday_admin_key',
//         key
//       );

//       return key;
//     };


//   /* ========================================
//      SINGLE FORM
//   ======================================== */

//   const handleChange =
//     (
//       event
//     ) => {
//       const {
//         name,
//         value,
//       } =
//         event.target;

//       setForm(
//         (
//           current
//         ) => ({
//           ...current,

//           [name]:
//             value,
//         })
//       );

//       if (error) {
//         setError('');
//       }
//     };


//   const handleSubmit =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       const title =
//         String(
//           form.title ||
//           ''
//         ).trim();

//       const firstname =
//         String(
//           form.firstname ||
//           ''
//         ).trim();

//       const lastname =
//         String(
//           form.lastname ||
//           ''
//         ).trim();

//       const kcusername =
//         normalizeKcUsername(
//           form.kcusername
//         );

//       if (
//         !title ||
//         !firstname ||
//         !lastname ||
//         !kcusername
//       ) {
//         setError(
//           'Title, firstname, lastname and KingsChat username are required.'
//         );

//         return;
//       }

//       if (
//         ![
//           'VIP',
//           'VVIP',
//         ].includes(
//           form.dignitaryLevel
//         )
//       ) {
//         setError(
//           'Select VIP or VVIP.'
//         );

//         return;
//       }

//       setLoading(
//         true
//       );

//       setError('');
//       setCreated(null);
//       setCopiedLink(false);
//       setCopiedCode(false);
//       setCopiedInvite(false);
//       setSentInvite(false);

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/dignitary/create`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',

//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 JSON.stringify({
//                   title,
//                   firstname,
//                   lastname,

//                   /*
//                    * We always send this without @.
//                    */
//                   kcusername,

//                   dignitaryLevel:
//                     form.dignitaryLevel,
//                 }),
//             }
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'Unable to create this dignitary invitation.'
//           );
//         }

//         setCreated(
//           result.data
//         );

//         setForm(
//           initialForm
//         );

//         const newCode =
//           normalizeInvitationCode(
//             result.data
//               ?.invitationCode ||
//               result.data
//                 ?.invitationLink ||
//               ''
//           );

//         if (newCode) {
//           setInvitationCode(
//             newCode
//           );
//         }
//       } catch (
//         err
//       ) {
//         setError(
//           err.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       } finally {
//         setLoading(
//           false
//         );
//       }
//     };


//   const getCreatedInvitationCode =
//     () =>
//       normalizeInvitationCode(
//         created
//           ?.invitationCode ||
//         created
//           ?.invitationLink ||
//         ''
//       );


//   const getCreatedInvitationLink =
//     () =>
//       buildInvitationLink(
//         created
//           ?.invitationCode,

//         created
//           ?.invitationLink ||
//         ''
//       );


//   const getCreatedInvitationMessage =
//     () =>
//       buildInvitationMessage({
//         fullName:
//           created
//             ?.fullName ||
//           '',

//         invitationLink:
//           getCreatedInvitationLink(),
//       });


//   const getCreatedKcUsername =
//     () =>
//       normalizeKcUsername(
//         created
//           ?.kcusername ||
//         created
//           ?.kc_username ||
//         ''
//       );


//   const getCreatedKingsChatUrl =
//     () =>
//       buildKingsChatProfileUrl(
//         getCreatedKcUsername()
//       );


//   const copyInvitationMessage =
//     async () => {
//       const message =
//         getCreatedInvitationMessage();

//       if (!message) {
//         setError(
//           'No invitation message is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           message
//         );

//         setCopiedInvite(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedInvite(
//               false
//             ),
//           1800
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation message.'
//         );
//       }
//     };


//   /*
//    * SEND INVITE:
//    *
//    * 1. Opens:
//    *    https://kingschat.online/user/{kcusername}
//    *
//    * 2. Copies the exact invitation message used by
//    *    "Copy Invite Message".
//    *
//    * You can then paste the copied message to the invitee
//    * inside KingsChat.
//    */
//   const sendCreatedInviteOnKingsChat =
//     async () => {
//       const profileUrl =
//         getCreatedKingsChatUrl();

//       if (!profileUrl) {
//         setError(
//           'No KingsChat username is available for this invitee.'
//         );

//         return;
//       }

//       /*
//        * Open immediately so the browser treats this as
//        * a direct user-click and does not block the new tab.
//        */
//       window.open(
//         profileUrl,
//         '_blank',
//         'noopener,noreferrer'
//       );

//       try {
//         await copyTextToClipboard(
//           getCreatedInvitationMessage()
//         );

//         setSentInvite(
//           true
//         );

//         setCopiedInvite(
//           true
//         );

//         setTimeout(
//           () => {
//             setSentInvite(
//               false
//             );

//             setCopiedInvite(
//               false
//             );
//           },
//           2200
//         );
//       } catch {
//         setError(
//           'KingsChat was opened, but the invitation message could not be copied automatically. Click "Copy Invite Message" and paste it in KingsChat.'
//         );
//       }
//     };


//   const copyInvitationLink =
//     async () => {
//       const link =
//         getCreatedInvitationLink();

//       if (!link) {
//         setError(
//           'No invitation link is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           link
//         );

//         setCopiedLink(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedLink(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation link.'
//         );
//       }
//     };


//   const copyInvitationCode =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           code
//         );

//         setCopiedCode(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedCode(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation code.'
//         );
//       }
//     };


//   const createAnother =
//     () => {
//       setCreated(
//         null
//       );

//       setError('');
//       setCopiedCode(false);
//       setCopiedLink(false);
//       setCopiedInvite(false);
//       setSentInvite(false);
//     };


//   /* ========================================
//      DOWNLOAD BULK TEMPLATE
//   ======================================== */

//   const downloadBulkTemplate =
//     () => {
//       /*
//        * EXACTLY FOUR COLUMNS:
//        *
//        * Title | firstname | lastname | kcusername
//        *
//        * @ is optional for kcusername.
//        */
//       const worksheet =
//         XLSX.utils.aoa_to_sheet(
//           [
//             [
//               'Title',
//               'firstname',
//               'lastname',
//               'kcusername',
//             ],

//             [
//               'Pastor',
//               'Lanre',
//               'Famodu',
//               '@planre',
//             ],
//           ]
//         );

//       worksheet[
//         '!cols'
//       ] = [
//         {
//           wch:
//             20,
//         },

//         {
//           wch:
//             24,
//         },

//         {
//           wch:
//             24,
//         },

//         {
//           wch:
//             30,
//         },
//       ];

//       const workbook =
//         XLSX.utils.book_new();

//       XLSX.utils.book_append_sheet(
//         workbook,
//         worksheet,
//         'Dignitary Upload'
//       );

//       XLSX.writeFile(
//         workbook,
//         'Dignitary_Bulk_Upload_Template.xlsx'
//       );
//     };


//   /* ========================================
//      BULK UPLOAD
//   ======================================== */

//   const handleBulkUpload =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setBulkError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (!bulkFile) {
//         setBulkError(
//           'Choose the completed Excel file.'
//         );

//         return;
//       }

//       if (
//         !/\.xlsx$/i.test(
//           bulkFile.name
//         )
//       ) {
//         setBulkError(
//           'Only .xlsx Excel files are allowed.'
//         );

//         return;
//       }

//       setBulkLoading(
//         true
//       );

//       setBulkError('');
//       setBulkRowErrors([]);
//       setBulkResults([]);
//       setCopiedBulkKey('');
//       setSentBulkKey('');

//       try {
//         const formData =
//           new FormData();

//         formData.append(
//           'file',
//           bulkFile
//         );

//         /*
//          * Excel stays four columns.
//          * The selected level applies to the whole batch.
//          */
//         formData.append(
//           'dignitaryLevel',
//           bulkDignitaryLevel
//         );

//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries/bulk-upload`,
//             {
//               method:
//                 'POST',

//               /*
//                * Do not manually set Content-Type for FormData.
//                */
//               headers: {
//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 formData,
//             }
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           if (
//             Array.isArray(
//               result.errors
//             )
//           ) {
//             setBulkRowErrors(
//               result.errors
//             );
//           }

//           throw new Error(
//             result.message ||
//               'Unable to upload dignitaries.'
//           );
//         }

//         setBulkResults(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );

//         setBulkFile(
//           null
//         );

//         const fileInput =
//           document.getElementById(
//             'dignitary-bulk-file'
//           );

//         if (
//           fileInput
//         ) {
//           fileInput.value =
//             '';
//         }
//       } catch (
//         err
//       ) {
//         setBulkError(
//           err.message ||
//             'Unable to upload dignitaries.'
//         );
//       } finally {
//         setBulkLoading(
//           false
//         );
//       }
//     };


//   const copyBulkValue =
//     async (
//       value,
//       key
//     ) => {
//       try {
//         await copyTextToClipboard(
//           value
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () =>
//             setCopiedBulkKey(
//               ''
//             ),
//           1400
//         );
//       } catch {
//         setBulkError(
//           'Unable to copy automatically.'
//         );
//       }
//     };


//   const getBulkInvitationLink =
//     (
//       item
//     ) =>
//       buildInvitationLink(
//         item
//           ?.invitationCode,

//         item
//           ?.invitationLink ||
//         ''
//       );


//   const getBulkInvitationMessage =
//     (
//       item
//     ) =>
//       buildInvitationMessage({
//         fullName:
//           item
//             ?.fullName ||
//           '',

//         invitationLink:
//           getBulkInvitationLink(
//             item
//           ),
//       });


//   const getBulkKcUsername =
//     (
//       item
//     ) =>
//       normalizeKcUsername(
//         item
//           ?.kcusername ||
//         item
//           ?.kc_username ||
//         ''
//       );


//   const getBulkKingsChatUrl =
//     (
//       item
//     ) =>
//       buildKingsChatProfileUrl(
//         getBulkKcUsername(
//           item
//         )
//       );


//   /*
//    * Per-invitee bulk SEND INVITE.
//    */
//   const sendBulkInviteOnKingsChat =
//     async (
//       item,
//       key
//     ) => {
//       const profileUrl =
//         getBulkKingsChatUrl(
//           item
//         );

//       if (!profileUrl) {
//         setBulkError(
//           `No KingsChat username is available for ${item?.fullName || 'this invitee'}.`
//         );

//         return;
//       }

//       window.open(
//         profileUrl,
//         '_blank',
//         'noopener,noreferrer'
//       );

//       try {
//         await copyTextToClipboard(
//           getBulkInvitationMessage(
//             item
//           )
//         );

//         setSentBulkKey(
//           key
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () => {
//             setSentBulkKey(
//               ''
//             );

//             setCopiedBulkKey(
//               ''
//             );
//           },
//           2200
//         );
//       } catch {
//         setBulkError(
//           'KingsChat was opened, but the invitation message could not be copied automatically. Copy the invite manually and paste it in KingsChat.'
//         );
//       }
//     };


//   const copyAllBulkInvites =
//     async () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         setBulkError(
//           'There are no generated invitations to copy.'
//         );

//         return;
//       }

//       const allMessages =
//         bulkResults
//           .map(
//             (
//               item
//             ) =>
//               getBulkInvitationMessage(
//                 item
//               )
//           )
//           .join(
//             '\n\n------------------------------\n\n'
//           );

//       await copyBulkValue(
//         allMessages,
//         'all-invites'
//       );
//     };


//   const downloadBulkResults =
//     () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         return;
//       }

//       const rows = [
//         [
//           'Title',
//           'firstname',
//           'lastname',
//           'kcusername',
//           'VIP/VVIP',
//           'Invitation Code',
//           'Invitation Link',
//           'KingsChat Profile',
//           'Invitation Message',
//         ],

//         ...bulkResults.map(
//           (
//             item
//           ) => [
//             item.title ||
//               '',

//             item.firstname ||
//               '',

//             item.lastname ||
//               '',

//             getBulkKcUsername(
//               item
//             ),

//             item.dignitaryLevel ||
//               'VIP',

//             item.invitationCode,

//             getBulkInvitationLink(
//               item
//             ),

//             getBulkKingsChatUrl(
//               item
//             ),

//             getBulkInvitationMessage(
//               item
//             ),
//           ]
//         ),
//       ];

//       const csv =
//         rows
//           .map(
//             (
//               row
//             ) =>
//               row
//                 .map(
//                   escapeCsv
//                 )
//                 .join(',')
//           )
//           .join(
//             '\r\n'
//           );

//       const blob =
//         new Blob(
//           [
//             csv,
//           ],
//           {
//             type:
//               'text/csv;charset=utf-8;',
//           }
//         );

//       const url =
//         URL.createObjectURL(
//           blob
//         );

//       const anchor =
//         document.createElement(
//           'a'
//         );

//       anchor.href =
//         url;

//       anchor.download =
//         'COS_Dignitary_Invitation_Results.csv';

//       document.body.appendChild(
//         anchor
//       );

//       anchor.click();
//       anchor.remove();

//       URL.revokeObjectURL(
//         url
//       );
//     };


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const confirmAndOpenInvitation =
//     async (
//       rawCode
//     ) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP or VVIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(
//         true
//       );

//       setInvitationLookupError(
//         ''
//       );

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//               code
//             )}`
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No invitation was found with that code.'
//           );
//         }

//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );
//       } catch (
//         err
//       ) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };


//   const handleInvitationLookup =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };


//   const openCreatedInvitation =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };


//   /* ========================================
//      RENDER
//   ======================================== */

//   return (
//     <div className="dignitary-admin-page">
//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />


//       <motion.main
//         className="dignitary-admin-card dignitary-admin-card--wide"
//         initial={{
//           opacity:
//             0,

//           y:
//             24,
//         }}
//         animate={{
//           opacity:
//             1,

//           y:
//             0,
//         }}
//         transition={{
//           duration:
//             0.45,
//         }}
//       >
//         <div className="dignitary-admin-lock">
//           VIP / VVIP
//         </div>

//         <span className="dignitary-admin-eyebrow">
//           Private Admin
//         </span>

//         <h1>
//           Dignitary Invitations
//         </h1>

//         <p className="dignitary-admin-intro">
//           Create single invitations with KingsChat usernames,
//           or upload multiple dignitaries and send each invite
//           directly from their KingsChat profile.
//         </p>


//         {/* =====================================
//             ADMIN KEY
//         ===================================== */}

//         <section className="dignitary-shared-admin">
//           <label htmlFor="dignitary-admin-key">
//             Admin Access Key
//           </label>

//           <div className="dignitary-password-wrap">
//             <input
//               id="dignitary-admin-key"
//               type={
//                 showAdminKey
//                   ? 'text'
//                   : 'password'
//               }
//               value={
//                 adminKey
//               }
//               onChange={(
//                 event
//               ) => {
//                 setAdminKey(
//                   event.target.value
//                 );

//                 setError('');
//                 setBulkError('');
//               }}
//               placeholder="Enter your private admin key"
//               autoComplete="off"
//             />

//             <button
//               type="button"
//               onClick={() =>
//                 setShowAdminKey(
//                   (
//                     current
//                   ) =>
//                     !current
//                 )
//               }
//             >
//               {showAdminKey
//                 ? 'Hide'
//                 : 'Show'}
//             </button>
//           </div>
//         </section>


//         {/* =====================================
//             TABS
//         ===================================== */}

//         <div className="dignitary-mode-tabs">
//           <button
//             type="button"
//             className={
//               activeMode ===
//               'single'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'single'
//               );

//               setBulkError('');
//             }}
//           >
//             Single Invitation
//           </button>


//           <button
//             type="button"
//             className={
//               activeMode ===
//               'bulk'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'bulk'
//               );

//               setError('');
//             }}
//           >
//             Bulk Upload
//           </button>
//         </div>


//         {/* =====================================
//             SINGLE CREATE
//         ===================================== */}

//         {activeMode ===
//           'single' && (
//           <section className="dignitary-mode-panel">
//             {error && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {error}
//               </div>
//             )}


//             {created ? (
//               <motion.div
//                 className="dignitary-created"
//                 initial={{
//                   opacity:
//                     0,

//                   scale:
//                     0.98,
//                 }}
//                 animate={{
//                   opacity:
//                     1,

//                   scale:
//                     1,
//                 }}
//               >
//                 <div className="dignitary-created-check">
//                   ✓
//                 </div>

//                 <span className="dignitary-created-label">
//                   Invitation Created
//                 </span>

//                 <div
//                   className={`dignitary-level-pill dignitary-level-pill--${String(
//                     created.dignitaryLevel ||
//                     'VIP'
//                   ).toLowerCase()}`}
//                 >
//                   {created.dignitaryLevel ||
//                     'VIP'}
//                   {' · '}
//                   {(created.dignitaryLevel ||
//                     'VIP') ===
//                   'VVIP'
//                     ? 'Gold QR'
//                     : 'Purple QR'}
//                 </div>

//                 <h2>
//                   {created.fullName}
//                 </h2>


//                 {getCreatedKcUsername() && (
//                   <div className="dignitary-created-code">
//                     <span>
//                       KingsChat Username
//                     </span>

//                     <strong>
//                       @{getCreatedKcUsername()}
//                     </strong>

//                     <a
//                       href={
//                         getCreatedKingsChatUrl()
//                       }
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       Open KingsChat Profile
//                     </a>
//                   </div>
//                 )}


//                 <div className="dignitary-created-code">
//                   <span>
//                     Invitation Code
//                   </span>

//                   <strong>
//                     {getCreatedInvitationCode()}
//                   </strong>

//                   <button
//                     type="button"
//                     className="dignitary-copy-code-button"
//                     onClick={
//                       copyInvitationCode
//                     }
//                   >
//                     {copiedCode
//                       ? 'Code Copied ✓'
//                       : 'Copy Invitation Code'}
//                   </button>
//                 </div>


//                 <div className="dignitary-access-box">
//                   <span>
//                     ACCESS
//                   </span>

//                   <strong>
//                     ✓ Thanksgiving Service
//                   </strong>

//                   <strong>
//                     ✓ Reception / Banquet
//                   </strong>
//                 </div>


//                 <div className="dignitary-link-box">
//                   <span>
//                     Private Invitation Link
//                   </span>

//                   <input
//                     type="text"
//                     value={
//                       getCreatedInvitationLink()
//                     }
//                     readOnly
//                   />


//                   <div className="dignitary-created-actions">
//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationLink
//                       }
//                     >
//                       {copiedLink
//                         ? 'Link Copied ✓'
//                         : 'Copy Invitation Link'}
//                     </button>


//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationMessage
//                       }
//                     >
//                       {copiedInvite
//                         ? 'Invite Message Copied ✓'
//                         : 'Copy Invite Message'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-send-kingschat-button"
//                       onClick={
//                         sendCreatedInviteOnKingsChat
//                       }
//                       disabled={
//                         !getCreatedKcUsername()
//                       }
//                     >
//                       {sentInvite
//                         ? 'Message Copied · KingsChat Opened ✓'
//                         : 'Send Invite'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-view-button"
//                       onClick={
//                         openCreatedInvitation
//                       }
//                       disabled={
//                         invitationLookupLoading
//                       }
//                     >
//                       View Invitation
//                     </button>
//                   </div>
//                 </div>


//                 <p>
//                   <strong>
//                     Send Invite
//                   </strong>
//                   {' '}
//                   opens
//                   {' '}
//                   {getCreatedKcUsername()
//                     ? `https://kingschat.online/user/${getCreatedKcUsername()}`
//                     : 'the invitee’s KingsChat profile'}
//                   {' '}
//                   and copies the invitation message to your clipboard.
//                 </p>


//                 <button
//                   type="button"
//                   className="dignitary-secondary-button"
//                   onClick={
//                     createAnother
//                   }
//                 >
//                   Create Another Invitation
//                 </button>
//               </motion.div>
//             ) : (
//               <form
//                 className="dignitary-admin-form"
//                 onSubmit={
//                   handleSubmit
//                 }
//               >
//                 <div className="dignitary-admin-divider">
//                   <span />

//                   <b>
//                     SINGLE DIGNITARY
//                   </b>

//                   <span />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-title">
//                     Title
//                   </label>

//                   <input
//                     id="dignitary-title"
//                     name="title"
//                     type="text"
//                     value={
//                       form.title
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Pastor, Sister, Deacon, Brother..."
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-firstname">
//                     First Name
//                   </label>

//                   <input
//                     id="dignitary-firstname"
//                     name="firstname"
//                     type="text"
//                     value={
//                       form.firstname
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter first name"
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-lastname">
//                     Last Name
//                   </label>

//                   <input
//                     id="dignitary-lastname"
//                     name="lastname"
//                     type="text"
//                     value={
//                       form.lastname
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter last name"
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-kcusername">
//                     KingsChat Username
//                   </label>

//                   <input
//                     id="dignitary-kcusername"
//                     name="kcusername"
//                     type="text"
//                     value={
//                       form.kcusername
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="@smartyk or smartyk"
//                     autoCapitalize="none"
//                     autoCorrect="off"
//                     spellCheck="false"
//                     required
//                   />

//                   <small>
//                     The @ is optional. It is stored without @.
//                   </small>
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-level">
//                     VIP / VVIP
//                   </label>

//                   <select
//                     id="dignitary-level"
//                     name="dignitaryLevel"
//                     value={
//                       form.dignitaryLevel
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     required
//                   >
//                     <option value="VIP">
//                       VIP — Purple QR
//                     </option>

//                     <option value="VVIP">
//                       VVIP — Gold QR
//                     </option>
//                   </select>
//                 </div>


//                 <motion.button
//                   type="submit"
//                   className="dignitary-admin-submit"
//                   disabled={
//                     loading
//                   }
//                   whileHover={
//                     !loading
//                       ? {
//                           scale:
//                             1.01,
//                         }
//                       : {}
//                   }
//                   whileTap={
//                     !loading
//                       ? {
//                           scale:
//                             0.99,
//                         }
//                       : {}
//                   }
//                 >
//                   {loading
//                     ? 'Creating Invitation…'
//                     : 'Create Private Invitation'}
//                 </motion.button>
//               </form>
//             )}
//           </section>
//         )}


//         {/* =====================================
//             BULK UPLOAD
//         ===================================== */}

//         {activeMode ===
//           'bulk' && (
//           <section className="dignitary-mode-panel">
//             <div className="dignitary-bulk-intro">
//               <div>
//                 <span>
//                   EXCEL TEMPLATE
//                 </span>

//                 <h2>
//                   Four fields only
//                 </h2>

//                 <p>
//                   The Excel template contains
//                   <strong> Title</strong>,
//                   <strong> firstname</strong>,
//                   <strong> lastname</strong> and
//                   <strong> kcusername</strong>.
//                   The @ in the KingsChat username is optional.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 className="dignitary-template-button"
//                 onClick={
//                   downloadBulkTemplate
//                 }
//               >
//                 Download Excel Template
//               </button>
//             </div>


//             <div className="dignitary-category-guide">
//               <div className="dignitary-category-guide--vip">
//                 <span>
//                   VIP
//                 </span>

//                 <strong>
//                   Purple QR Code
//                 </strong>
//               </div>

//               <div className="dignitary-category-guide--vvip">
//                 <span>
//                   VVIP
//                 </span>

//                 <strong>
//                   Gold QR Code
//                 </strong>
//               </div>
//             </div>


//             <form
//               className="dignitary-bulk-form"
//               onSubmit={
//                 handleBulkUpload
//               }
//             >
//               <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-bulk-level">
//                   Level for this upload
//                 </label>

//                 <select
//                   id="dignitary-bulk-level"
//                   value={
//                     bulkDignitaryLevel
//                   }
//                   onChange={(
//                     event
//                   ) =>
//                     setBulkDignitaryLevel(
//                       event.target.value
//                     )
//                   }
//                 >
//                   <option value="VIP">
//                     VIP
//                   </option>

//                   <option value="VVIP">
//                     VVIP
//                   </option>
//                 </select>

//                 <small>
//                   This applies to every invitee in the uploaded sheet.
//                 </small>
//               </div>


//               <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-bulk-file">
//                   Upload Completed Excel File
//                 </label>

//                 <input
//                   id="dignitary-bulk-file"
//                   type="file"
//                   accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                   onChange={(
//                     event
//                   ) => {
//                     setBulkFile(
//                       event.target
//                         .files?.[0] ||
//                       null
//                     );

//                     setBulkError('');
//                     setBulkRowErrors([]);
//                   }}
//                   required
//                 />

//                 {bulkFile && (
//                   <small>
//                     Selected: {bulkFile.name}
//                   </small>
//                 )}
//               </div>


//               <button
//                 type="submit"
//                 className="dignitary-admin-submit"
//                 disabled={
//                   bulkLoading
//                 }
//               >
//                 {bulkLoading
//                   ? 'Uploading & Creating Invitations…'
//                   : 'Upload & Generate Invitations'}
//               </button>
//             </form>


//             {bulkError && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {bulkError}
//               </div>
//             )}


//             {bulkRowErrors.length >
//               0 && (
//               <div className="dignitary-bulk-row-errors">
//                 <strong>
//                   Fix these rows and upload again:
//                 </strong>

//                 {bulkRowErrors.map(
//                   (
//                     item,
//                     index
//                   ) => (
//                     <p
//                       key={`${item.row}-${index}`}
//                     >
//                       Row {item.row}
//                       {item.kcusername
//                         ? ` — @${normalizeKcUsername(
//                             item.kcusername
//                           )}`
//                         : ''}
//                       {item.fullName
//                         ? ` — ${item.fullName}`
//                         : ''}
//                       : {item.message}
//                     </p>
//                   )
//                 )}
//               </div>
//             )}


//             {bulkResults.length >
//               0 && (
//               <div className="dignitary-bulk-results">
//                 <div className="dignitary-bulk-results-head">
//                   <div>
//                     <span>
//                       IMPORT COMPLETE
//                     </span>

//                     <h2>
//                       {bulkSummary.total} Invitations Created
//                     </h2>
//                   </div>


//                   <button
//                     type="button"
//                     onClick={
//                       copyAllBulkInvites
//                     }
//                   >
//                     {copiedBulkKey ===
//                     'all-invites'
//                       ? 'All Invite Messages Copied ✓'
//                       : 'Copy All Invite Messages'}
//                   </button>


//                   <button
//                     type="button"
//                     onClick={
//                       downloadBulkResults
//                     }
//                   >
//                     Download Results CSV
//                   </button>
//                 </div>


//                 <div className="dignitary-bulk-stats">
//                   <div>
//                     <span>
//                       Total
//                     </span>

//                     <strong>
//                       {bulkSummary.total}
//                     </strong>
//                   </div>

//                   <div className="is-vip">
//                     <span>
//                       VIP
//                     </span>

//                     <strong>
//                       {bulkSummary.VIP}
//                     </strong>
//                   </div>

//                   <div className="is-vvip">
//                     <span>
//                       VVIP
//                     </span>

//                     <strong>
//                       {bulkSummary.VVIP}
//                     </strong>
//                   </div>
//                 </div>


//                 <div className="dignitary-bulk-table-wrap">
//                   <table className="dignitary-bulk-table">
//                     <thead>
//                       <tr>
//                         <th>
//                           Invitee
//                         </th>

//                         <th>
//                           KingsChat
//                         </th>

//                         <th>
//                           VIP/VVIP
//                         </th>

//                         <th>
//                           Copy Invite
//                         </th>

//                         <th>
//                           Send Invite
//                         </th>

//                         <th>
//                           Invitation Code
//                         </th>

//                         <th>
//                           Invitation Link
//                         </th>
//                       </tr>
//                     </thead>


//                     <tbody>
//                       {bulkResults.map(
//                         (
//                           item,
//                           index
//                         ) => {
//                           const codeKey =
//                             `code-${index}`;

//                           const linkKey =
//                             `link-${index}`;

//                           const inviteKey =
//                             `invite-${index}`;

//                           const sendKey =
//                             `send-${index}`;

//                           const level =
//                             item.dignitaryLevel ||
//                             'VIP';

//                           const kcusername =
//                             getBulkKcUsername(
//                               item
//                             );

//                           return (
//                             <tr
//                               key={
//                                 item.id ||
//                                 item.invitationCode
//                               }
//                             >
//                               <td>
//                                 <strong>
//                                   {item.fullName}
//                                 </strong>
//                               </td>


//                               <td>
//                                 {kcusername ? (
//                                   <>
//                                     <code>
//                                       @{kcusername}
//                                     </code>

//                                     <a
//                                       href={
//                                         getBulkKingsChatUrl(
//                                           item
//                                         )
//                                       }
//                                       target="_blank"
//                                       rel="noreferrer"
//                                     >
//                                       Open
//                                     </a>
//                                   </>
//                                 ) : (
//                                   <span>
//                                     No username
//                                   </span>
//                                 )}
//                               </td>


//                               <td>
//                                 <span
//                                   className={`dignitary-level-pill dignitary-level-pill--${level.toLowerCase()}`}
//                                 >
//                                   {level}
//                                 </span>
//                               </td>


//                               <td>
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationMessage(
//                                         item
//                                       ),
//                                       inviteKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   inviteKey
//                                     ? 'Invite Copied ✓'
//                                     : 'Copy Invite'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <button
//                                   type="button"
//                                   className="dignitary-send-kingschat-button"
//                                   disabled={
//                                     !kcusername
//                                   }
//                                   onClick={() =>
//                                     sendBulkInviteOnKingsChat(
//                                       item,
//                                       sendKey
//                                     )
//                                   }
//                                 >
//                                   {sentBulkKey ===
//                                   sendKey
//                                     ? 'Message Copied · Opened ✓'
//                                     : 'Send Invite'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <code>
//                                   {item.invitationCode}
//                                 </code>

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       item.invitationCode,
//                                       codeKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   codeKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Code'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <input
//                                   type="text"
//                                   readOnly
//                                   value={
//                                     getBulkInvitationLink(
//                                       item
//                                     )
//                                   }
//                                 />

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationLink(
//                                         item
//                                       ),
//                                       linkKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   linkKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Link'}
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         }
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </section>
//         )}


//         {/* =====================================
//             OPEN EXISTING INVITATION
//         ===================================== */}

//         <section className="dignitary-shared-admin">
//           <form
//             onSubmit={
//               handleInvitationLookup
//             }
//           >
//             <label htmlFor="existing-invitation-code">
//               Open Existing Invitation
//             </label>

//             <div className="dignitary-password-wrap">
//               <input
//                 id="existing-invitation-code"
//                 type="text"
//                 value={
//                   invitationCode
//                 }
//                 onChange={(
//                   event
//                 ) => {
//                   setInvitationCode(
//                     event.target.value
//                   );

//                   setInvitationLookupError(
//                     ''
//                   );
//                 }}
//                 placeholder="VIP-... or invitation link"
//               />

//               <button
//                 type="submit"
//                 disabled={
//                   invitationLookupLoading
//                 }
//               >
//                 {invitationLookupLoading
//                   ? 'Opening…'
//                   : 'Open'}
//               </button>
//             </div>
//           </form>

//           {invitationLookupError && (
//             <div
//               className="dignitary-admin-alert"
//               role="alert"
//             >
//               {invitationLookupError}
//             </div>
//           )}
//         </section>
//       </motion.main>
//     </div>
//   );
// }





// import React, {
//   useMemo,
//   useState,
// } from 'react';

// import {
//   motion,
// } from 'framer-motion';

// import {
//   useNavigate,
// } from 'react-router-dom';

// import * as XLSX
//   from 'xlsx';

// import './DignitarySuperMin.css';


// /* =========================================================
//    API / INVITATION URL CONFIGURATION

//    - On localhost / 127.0.0.1, requests go to your local API.
//    - On a deployed website, requests go to your Render API.
//    - REACT_APP_API_URL takes priority when explicitly set.
//    - Links copied and sent to invitees use the PUBLIC frontend,
//      not localhost, so recipients can open their invitation.

//    .env.development example:
//       REACT_APP_API_URL=http://localhost:5000
//       REACT_APP_INVITATION_BASE_URL=https://celebratingcos.site

//    .env.production example:
//       REACT_APP_API_URL=https://lsdcnodejs-api.onrender.com
//       REACT_APP_INVITATION_BASE_URL=https://celebratingcos.site

//    If your local Express server runs on a port other than 5000,
//    change REACT_APP_API_URL in .env.development to match it.
//    Restart your React dev server after changing .env files.
// ========================================================= */

// const LOCAL_API_URL = 'http://localhost:3001';
// const LIVE_API_URL = 'https://lsdcnodejs-api.onrender.com';
// const LIVE_FRONTEND_URL = 'https://celebratingcos.site';

// const isLocalhost =
//   typeof window !== 'undefined' &&
//   ['localhost', '127.0.0.1', '::1', '[::1]'].includes(
//     window.location.hostname
//   );

// // Set REACT_APP_API_URL to override the automatic selection.
// const API_URL = String(
//   process.env.REACT_APP_API_URL ||
//     (isLocalhost
//       ? process.env.REACT_APP_LOCAL_API_URL || LOCAL_API_URL
//       : process.env.REACT_APP_LIVE_API_URL || LIVE_API_URL)
// )
//   .trim()
//   .replace(/\/+$/, '');

// // Public link to share with dignitaries (never a private localhost URL).
// const INVITATION_BASE_URL = String(
//   process.env.REACT_APP_INVITATION_BASE_URL || LIVE_FRONTEND_URL
// )
//   .trim()
//   .replace(/\/+$/, '');


// const initialForm = {
//   title: '',
//   firstname: '',
//   lastname: '',
//   kcusername: '',
//   dignitaryLevel: 'VIP',
// };


// /* ==========================================
//    HELPERS
// ========================================== */

// const normalizeInvitationCode = (
//   value = ''
// ) => {
//   const raw =
//     String(
//       value ||
//       ''
//     ).trim();

//   if (!raw) {
//     return '';
//   }

//   try {
//     if (
//       raw.startsWith(
//         'http://'
//       ) ||
//       raw.startsWith(
//         'https://'
//       )
//     ) {
//       const url =
//         new URL(
//           raw
//         );

//       const parts =
//         url.pathname
//           .split('/')
//           .filter(Boolean);

//       const invitationIndex =
//         parts.findIndex(
//           (part) =>
//             part.toLowerCase() ===
//             'invitation'
//         );

//       if (
//         invitationIndex !== -1 &&
//         parts[
//           invitationIndex + 1
//         ]
//       ) {
//         return decodeURIComponent(
//           parts[
//             invitationIndex + 1
//           ]
//         );
//       }

//       return decodeURIComponent(
//         parts[
//           parts.length - 1
//         ] ||
//         ''
//       );
//     }
//   } catch {
//     // Treat it as a raw invitation code.
//   }

//   const marker =
//     '/invitation/';

//   const lowerRaw =
//     raw.toLowerCase();

//   const markerIndex =
//     lowerRaw.indexOf(
//       marker
//     );

//   if (
//     markerIndex !== -1
//   ) {
//     return decodeURIComponent(
//       raw
//         .slice(
//           markerIndex +
//             marker.length
//         )
//         .split('?')[0]
//         .split('#')[0]
//         .replace(
//           /\/+$/,
//           ''
//         )
//     );
//   }

//   return raw
//     .split('?')[0]
//     .split('#')[0]
//     .replace(
//       /\/+$/,
//       ''
//     );
// };


// const normalizeKcUsername = (
//   value = ''
// ) =>
//   String(
//     value ||
//     ''
//   )
//     .trim()
//     .replace(
//       /^@+/,
//       ''
//     )
//     .trim()
//     .toLowerCase();


// const buildKingsChatProfileUrl = (
//   kcusername = ''
// ) => {
//   const username =
//     normalizeKcUsername(
//       kcusername
//     );

//   if (!username) {
//     return '';
//   }

//   return `https://kingschat.online/user/${encodeURIComponent(
//     username
//   )}`;
// };


// const copyTextToClipboard =
//   async (
//     text
//   ) => {
//     const value =
//       String(
//         text ||
//         ''
//       ).trim();

//     if (!value) {
//       throw new Error(
//         'There is nothing to copy.'
//       );
//     }

//     if (
//       navigator.clipboard &&
//       window.isSecureContext
//     ) {
//       await navigator.clipboard.writeText(
//         value
//       );

//       return;
//     }

//     const textarea =
//       document.createElement(
//         'textarea'
//       );

//     textarea.value =
//       value;

//     textarea.setAttribute(
//       'readonly',
//       ''
//     );

//     textarea.style.position =
//       'fixed';

//     textarea.style.left =
//       '-9999px';

//     textarea.style.opacity =
//       '0';

//     document.body.appendChild(
//       textarea
//     );

//     textarea.focus();
//     textarea.select();

//     const copied =
//       document.execCommand(
//         'copy'
//       );

//     textarea.remove();

//     if (!copied) {
//       throw new Error(
//         'Copy failed.'
//       );
//     }
//   };


// const buildInvitationLink = (
//   code,
//   fallbackLink = ''
// ) => {
//   const normalizedCode =
//     normalizeInvitationCode(
//       code ||
//       fallbackLink
//     );

//   if (!normalizedCode) {
//     return fallbackLink;
//   }

//   return `${INVITATION_BASE_URL}/invitation/${encodeURIComponent(
//     normalizedCode
//   )}`;
// };


// const formatInviteeSalutation = (
//   fullName = ''
// ) => {
//   const name =
//     String(
//       fullName ||
//       ''
//     ).trim();

//   if (!name) {
//     return 'Esteemed Guest';
//   }

//   if (
//     /^esteemed\b/i.test(
//       name
//     )
//   ) {
//     return name;
//   }

//   return `Esteemed ${name}`;
// };


// const buildInvitationMessage = ({
//   fullName,
//   invitationLink,
//   tableName = '',
// }) => {
//   const salutationName =
//     formatInviteeSalutation(
//       fullName
//     );

//   const link =
//     String(
//       invitationLink ||
//       ''
//     ).trim();

//   return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

// Dear ${salutationName},

// Greetings in the precious Name of our Lord Jesus Christ.

// We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

// *Event Details:*
// *Thanksgiving Service*: Bay 4, 10am prompt

// *Banquet*: The Angel Court, Immediately after the Thanksgiving
// ${tableName ? `*Assigned Table*: ${tableName}\n` : ''}
// Kindly click the link below to confirm your attendance, so your SEAT NUMBER can be sent to you.

// Link:
// ${link}

// We look forward to warmly welcoming you.

// Kind regards,
// *The Organising Committee*`;
// };


// const escapeCsv = (
//   value
// ) =>
//   `"${String(
//     value ??
//     ''
//   ).replace(
//     /"/g,
//     '""'
//   )}"`;


// /* ==========================================
//    MAIN COMPONENT
// ========================================== */

// export default function DignitarySuperMin() {
//   const navigate =
//     useNavigate();


//   /* ========================================
//      MAIN MODE
//   ======================================== */

//   const [
//     activeMode,
//     setActiveMode,
//   ] =
//     useState(
//       'single'
//     );


//   /* ========================================
//      ADMIN
//   ======================================== */

//   const [
//     adminKey,
//     setAdminKey,
//   ] =
//     useState(
//       () =>
//         sessionStorage.getItem(
//           'birthday_admin_key'
//         ) ||
//         ''
//     );

//   const [
//     showAdminKey,
//     setShowAdminKey,
//   ] =
//     useState(
//       false
//     );


//   /* ========================================
//      SINGLE INVITATION
//   ======================================== */

//   const [
//     form,
//     setForm,
//   ] =
//     useState(
//       initialForm
//     );

//   const [
//     loading,
//     setLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     error,
//     setError,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     created,
//     setCreated,
//   ] =
//     useState(
//       null
//     );

//   const [
//     copiedLink,
//     setCopiedLink,
//   ] =
//     useState(
//       false
//     );

//   const [
//     copiedCode,
//     setCopiedCode,
//   ] =
//     useState(
//       false
//     );

//   const [
//     copiedInvite,
//     setCopiedInvite,
//   ] =
//     useState(
//       false
//     );

//   const [
//     sentInvite,
//     setSentInvite,
//   ] =
//     useState(
//       false
//     );


//   /* ========================================
//      BULK INVITATION
//   ======================================== */

//   const [
//     bulkFile,
//     setBulkFile,
//   ] =
//     useState(
//       null
//     );

//   const [
//     bulkDignitaryLevel,
//     setBulkDignitaryLevel,
//   ] =
//     useState(
//       'VIP'
//     );

//   const [
//     bulkLoading,
//     setBulkLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     bulkError,
//     setBulkError,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     bulkRowErrors,
//     setBulkRowErrors,
//   ] =
//     useState(
//       []
//     );

//   const [
//     bulkResults,
//     setBulkResults,
//   ] =
//     useState(
//       []
//     );

//   const [
//     copiedBulkKey,
//     setCopiedBulkKey,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     sentBulkKey,
//     setSentBulkKey,
//   ] =
//     useState(
//       ''
//     );


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const [
//     invitationCode,
//     setInvitationCode,
//   ] =
//     useState(
//       ''
//     );

//   const [
//     invitationLookupLoading,
//     setInvitationLookupLoading,
//   ] =
//     useState(
//       false
//     );

//   const [
//     invitationLookupError,
//     setInvitationLookupError,
//   ] =
//     useState(
//       ''
//     );


//   /* ========================================
//      SUMMARY
//   ======================================== */

//   const bulkSummary =
//     useMemo(
//       () => ({
//         total:
//           bulkResults.length,

//         VIP:
//           bulkResults.filter(
//             (
//               item
//             ) =>
//               item.dignitaryLevel ===
//               'VIP'
//           ).length,

//         VVIP:
//           bulkResults.filter(
//             (
//               item
//             ) =>
//               item.dignitaryLevel ===
//               'VVIP'
//           ).length,
//       }),
//       [
//         bulkResults,
//       ]
//     );


//   /* ========================================
//      ADMIN KEY
//   ======================================== */

//   const ensureAdminKey =
//     () => {
//       const key =
//         adminKey.trim();

//       if (!key) {
//         return '';
//       }

//       sessionStorage.setItem(
//         'birthday_admin_key',
//         key
//       );

//       return key;
//     };


//   /* ========================================
//      SINGLE FORM
//   ======================================== */

//   const handleChange =
//     (
//       event
//     ) => {
//       const {
//         name,
//         value,
//       } =
//         event.target;

//       setForm(
//         (
//           current
//         ) => ({
//           ...current,

//           [name]:
//             value,
//         })
//       );

//       if (error) {
//         setError('');
//       }
//     };


//   const handleSubmit =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       const title =
//         String(
//           form.title ||
//           ''
//         ).trim();

//       const firstname =
//         String(
//           form.firstname ||
//           ''
//         ).trim();

//       const lastname =
//         String(
//           form.lastname ||
//           ''
//         ).trim();

//       const kcusername =
//         normalizeKcUsername(
//           form.kcusername
//         );

//       if (
//         !title ||
//         !firstname ||
//         !lastname ||
//         !kcusername
//       ) {
//         setError(
//           'Title, firstname, lastname and KingsChat username are required.'
//         );

//         return;
//       }

//       if (
//         ![
//           'VIP',
//           'VVIP',
//         ].includes(
//           form.dignitaryLevel
//         )
//       ) {
//         setError(
//           'Select VIP or VVIP.'
//         );

//         return;
//       }

//       setLoading(
//         true
//       );

//       setError('');
//       setCreated(null);
//       setCopiedLink(false);
//       setCopiedCode(false);
//       setCopiedInvite(false);
//       setSentInvite(false);

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/dignitary/create`,
//             {
//               method:
//                 'POST',

//               headers: {
//                 'Content-Type':
//                   'application/json',

//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 JSON.stringify({
//                   title,
//                   firstname,
//                   lastname,

//                   /*
//                    * We always send this without @.
//                    */
//                   kcusername,

//                   dignitaryLevel:
//                     form.dignitaryLevel,
//                 }),
//             }
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'Unable to create this dignitary invitation.'
//           );
//         }

//         setCreated(
//           result.data
//         );

//         setForm(
//           initialForm
//         );

//         const newCode =
//           normalizeInvitationCode(
//             result.data
//               ?.invitationCode ||
//               result.data
//                 ?.invitationLink ||
//               ''
//           );

//         if (newCode) {
//           setInvitationCode(
//             newCode
//           );
//         }
//       } catch (
//         err
//       ) {
//         setError(
//           err.message ||
//             'Unable to create this dignitary invitation.'
//         );
//       } finally {
//         setLoading(
//           false
//         );
//       }
//     };


//   const getCreatedInvitationCode =
//     () =>
//       normalizeInvitationCode(
//         created
//           ?.invitationCode ||
//         created
//           ?.invitationLink ||
//         ''
//       );


//   const getCreatedInvitationLink =
//     () =>
//       buildInvitationLink(
//         created
//           ?.invitationCode,

//         created
//           ?.invitationLink ||
//         ''
//       );


//   const getCreatedInvitationMessage =
//     () =>
//       buildInvitationMessage({
//         fullName:
//           created
//             ?.fullName ||
//           '',

//         invitationLink:
//           getCreatedInvitationLink(),
//       });


//   const getCreatedKcUsername =
//     () =>
//       normalizeKcUsername(
//         created
//           ?.kcusername ||
//         created
//           ?.kc_username ||
//         ''
//       );


//   const getCreatedKingsChatUrl =
//     () =>
//       buildKingsChatProfileUrl(
//         getCreatedKcUsername()
//       );


//   const copyInvitationMessage =
//     async () => {
//       const message =
//         getCreatedInvitationMessage();

//       if (!message) {
//         setError(
//           'No invitation message is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           message
//         );

//         setCopiedInvite(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedInvite(
//               false
//             ),
//           1800
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation message.'
//         );
//       }
//     };


//   /*
//    * SEND INVITE:
//    *
//    * 1. Opens:
//    *    https://kingschat.online/user/{kcusername}
//    *
//    * 2. Copies the exact invitation message used by
//    *    "Copy Invite Message".
//    *
//    * You can then paste the copied message to the invitee
//    * inside KingsChat.
//    */
//   const sendCreatedInviteOnKingsChat =
//     async () => {
//       const profileUrl =
//         getCreatedKingsChatUrl();

//       if (!profileUrl) {
//         setError(
//           'No KingsChat username is available for this invitee.'
//         );

//         return;
//       }

//       /*
//        * Open immediately so the browser treats this as
//        * a direct user-click and does not block the new tab.
//        */
//       window.open(
//         profileUrl,
//         '_blank',
//         'noopener,noreferrer'
//       );

//       try {
//         await copyTextToClipboard(
//           getCreatedInvitationMessage()
//         );

//         setSentInvite(
//           true
//         );

//         setCopiedInvite(
//           true
//         );

//         setTimeout(
//           () => {
//             setSentInvite(
//               false
//             );

//             setCopiedInvite(
//               false
//             );
//           },
//           2200
//         );
//       } catch {
//         setError(
//           'KingsChat was opened, but the invitation message could not be copied automatically. Click "Copy Invite Message" and paste it in KingsChat.'
//         );
//       }
//     };


//   const copyInvitationLink =
//     async () => {
//       const link =
//         getCreatedInvitationLink();

//       if (!link) {
//         setError(
//           'No invitation link is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           link
//         );

//         setCopiedLink(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedLink(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation link.'
//         );
//       }
//     };


//   const copyInvitationCode =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       try {
//         await copyTextToClipboard(
//           code
//         );

//         setCopiedCode(
//           true
//         );

//         setTimeout(
//           () =>
//             setCopiedCode(
//               false
//             ),
//           1600
//         );
//       } catch {
//         setError(
//           'Could not copy the invitation code.'
//         );
//       }
//     };


//   const createAnother =
//     () => {
//       setCreated(
//         null
//       );

//       setError('');
//       setCopiedCode(false);
//       setCopiedLink(false);
//       setCopiedInvite(false);
//       setSentInvite(false);
//     };


//   /* ========================================
//      DOWNLOAD BULK TEMPLATE
//   ======================================== */

//   const downloadBulkTemplate = () => {
//     const isVvip = bulkDignitaryLevel === 'VVIP';

//     const headers = [
//       'Title',
//       'firstname',
//       'lastname',
//       'kcusername',
//       ...(isVvip ? ['Table Name'] : []),
//     ];

//     const sheet = XLSX.utils.aoa_to_sheet([headers]);
//     sheet['!cols'] = [
//       { wch: 20 },
//       { wch: 25 },
//       { wch: 25 },
//       { wch: 30 },
//       ...(isVvip ? [{ wch: 30 }] : []),
//     ];

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(
//       workbook,
//       sheet,
//       'Dignitary Upload'
//     );
//     XLSX.writeFile(
//       workbook,
//       `COS_${bulkDignitaryLevel}_Dignitary_Upload_Template.xlsx`
//     );
//   };


//   /* ========================================
//      BULK UPLOAD
//   ======================================== */

//   const handleBulkUpload =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       const key =
//         ensureAdminKey();

//       if (!key) {
//         setBulkError(
//           'Enter your admin access key.'
//         );

//         return;
//       }

//       if (!bulkFile) {
//         setBulkError(
//           'Choose the completed Excel file.'
//         );

//         return;
//       }

//       if (
//         !/\.xlsx$/i.test(
//           bulkFile.name
//         )
//       ) {
//         setBulkError(
//           'Only .xlsx Excel files are allowed.'
//         );

//         return;
//       }

//       setBulkLoading(
//         true
//       );

//       setBulkError('');
//       setBulkRowErrors([]);
//       setBulkResults([]);
//       setCopiedBulkKey('');
//       setSentBulkKey('');

//       try {
//         const formData =
//           new FormData();

//         formData.append(
//           'file',
//           bulkFile
//         );

//         /*
//          * Excel stays four columns.
//          * The selected level applies to the whole batch.
//          */
//         formData.append(
//           'dignitaryLevel',
//           bulkDignitaryLevel
//         );

//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/admin/dignitaries/bulk-upload`,
//             {
//               method:
//                 'POST',

//               /*
//                * Do not manually set Content-Type for FormData.
//                */
//               headers: {
//                 'x-admin-key':
//                   key,
//               },

//               body:
//                 formData,
//             }
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           if (
//             Array.isArray(
//               result.errors
//             )
//           ) {
//             setBulkRowErrors(
//               result.errors
//             );
//           }

//           throw new Error(
//             result.message ||
//               'Unable to upload dignitaries.'
//           );
//         }

//         setBulkResults(
//           Array.isArray(
//             result.data
//           )
//             ? result.data
//             : []
//         );

//         setBulkFile(
//           null
//         );

//         const fileInput =
//           document.getElementById(
//             'dignitary-bulk-file'
//           );

//         if (
//           fileInput
//         ) {
//           fileInput.value =
//             '';
//         }
//       } catch (
//         err
//       ) {
//         setBulkError(
//           err.message ||
//             'Unable to upload dignitaries.'
//         );
//       } finally {
//         setBulkLoading(
//           false
//         );
//       }
//     };


//   const copyBulkValue =
//     async (
//       value,
//       key
//     ) => {
//       try {
//         await copyTextToClipboard(
//           value
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () =>
//             setCopiedBulkKey(
//               ''
//             ),
//           1400
//         );
//       } catch {
//         setBulkError(
//           'Unable to copy automatically.'
//         );
//       }
//     };


//   const getBulkInvitationLink =
//     (
//       item
//     ) =>
//       buildInvitationLink(
//         item
//           ?.invitationCode,

//         item
//           ?.invitationLink ||
//         ''
//       );


//   const getBulkInvitationMessage =
//     (
//       item
//     ) =>
//       buildInvitationMessage({
//         fullName:
//           item
//             ?.fullName ||
//           '',

//         invitationLink:
//           getBulkInvitationLink(
//             item
//           ),
//         tableName: item?.dignitaryLevel === 'VVIP'
//           ? String(item?.tableName || '').trim()
//           : '',
//       });


//   const getBulkKcUsername =
//     (
//       item
//     ) =>
//       normalizeKcUsername(
//         item
//           ?.kcusername ||
//         item
//           ?.kc_username ||
//         ''
//       );


//   const getBulkKingsChatUrl =
//     (
//       item
//     ) =>
//       buildKingsChatProfileUrl(
//         getBulkKcUsername(
//           item
//         )
//       );


//   /*
//    * Per-invitee bulk SEND INVITE.
//    */
//   const sendBulkInviteOnKingsChat =
//     async (
//       item,
//       key
//     ) => {
//       const profileUrl =
//         getBulkKingsChatUrl(
//           item
//         );

//       if (!profileUrl) {
//         setBulkError(
//           `No KingsChat username is available for ${item?.fullName || 'this invitee'}.`
//         );

//         return;
//       }

//       window.open(
//         profileUrl,
//         '_blank',
//         'noopener,noreferrer'
//       );

//       try {
//         await copyTextToClipboard(
//           getBulkInvitationMessage(
//             item
//           )
//         );

//         setSentBulkKey(
//           key
//         );

//         setCopiedBulkKey(
//           key
//         );

//         setTimeout(
//           () => {
//             setSentBulkKey(
//               ''
//             );

//             setCopiedBulkKey(
//               ''
//             );
//           },
//           2200
//         );
//       } catch {
//         setBulkError(
//           'KingsChat was opened, but the invitation message could not be copied automatically. Copy the invite manually and paste it in KingsChat.'
//         );
//       }
//     };


//   const copyAllBulkInvites =
//     async () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         setBulkError(
//           'There are no generated invitations to copy.'
//         );

//         return;
//       }

//       const allMessages =
//         bulkResults
//           .map(
//             (
//               item
//             ) =>
//               getBulkInvitationMessage(
//                 item
//               )
//           )
//           .join(
//             '\n\n------------------------------\n\n'
//           );

//       await copyBulkValue(
//         allMessages,
//         'all-invites'
//       );
//     };


//   const downloadBulkResults =
//     () => {
//       if (
//         bulkResults.length ===
//         0
//       ) {
//         return;
//       }

//       const rows = [
//         [
//           'Title',
//           'firstname',
//           'lastname',
//           'kcusername',
//           'VIP/VVIP',
//           ...(bulkResults.some((item) => item.dignitaryLevel === 'VVIP')
//             ? ['Table Name'] : []),
//           'Invitation Code',
//           'Invitation Link',
//           'KingsChat Profile',
//           'Invitation Message',
//         ],

//         ...bulkResults.map(
//           (
//             item
//           ) => [
//             item.title ||
//               '',

//             item.firstname ||
//               '',

//             item.lastname ||
//               '',

//             getBulkKcUsername(
//               item
//             ),

//             item.dignitaryLevel ||
//               'VIP',

//             ...(bulkResults.some((x) => x.dignitaryLevel === 'VVIP')
//               ? [item.tableName || ''] : []),

//             item.invitationCode,

//             getBulkInvitationLink(
//               item
//             ),

//             getBulkKingsChatUrl(
//               item
//             ),

//             getBulkInvitationMessage(
//               item
//             ),
//           ]
//         ),
//       ];

//       const csv =
//         rows
//           .map(
//             (
//               row
//             ) =>
//               row
//                 .map(
//                   escapeCsv
//                 )
//                 .join(',')
//           )
//           .join(
//             '\r\n'
//           );

//       const blob =
//         new Blob(
//           [
//             csv,
//           ],
//           {
//             type:
//               'text/csv;charset=utf-8;',
//           }
//         );

//       const url =
//         URL.createObjectURL(
//           blob
//         );

//       const anchor =
//         document.createElement(
//           'a'
//         );

//       anchor.href =
//         url;

//       anchor.download =
//         'COS_Dignitary_Invitation_Results.csv';

//       document.body.appendChild(
//         anchor
//       );

//       anchor.click();
//       anchor.remove();

//       URL.revokeObjectURL(
//         url
//       );
//     };


//   /* ========================================
//      OPEN EXISTING INVITATION
//   ======================================== */

//   const confirmAndOpenInvitation =
//     async (
//       rawCode
//     ) => {
//       const code =
//         normalizeInvitationCode(
//           rawCode
//         );

//       if (!code) {
//         setInvitationLookupError(
//           'Enter a valid VIP or VVIP invitation code.'
//         );

//         return;
//       }

//       setInvitationLookupLoading(
//         true
//       );

//       setInvitationLookupError(
//         ''
//       );

//       try {
//         const response =
//           await fetch(
//             `${API_URL}/api/birthday/invitation/${encodeURIComponent(
//               code
//             )}`
//           );

//         let result =
//           {};

//         try {
//           result =
//             await response.json();
//         } catch {
//           result =
//             {};
//         }

//         if (
//           !response.ok ||
//           !result.success
//         ) {
//           throw new Error(
//             result.message ||
//               'No invitation was found with that code.'
//           );
//         }

//         navigate(
//           `/invitation/${encodeURIComponent(
//             code
//           )}`
//         );
//       } catch (
//         err
//       ) {
//         setInvitationLookupError(
//           err.message ||
//             'Unable to confirm this invitation.'
//         );
//       } finally {
//         setInvitationLookupLoading(
//           false
//         );
//       }
//     };


//   const handleInvitationLookup =
//     async (
//       event
//     ) => {
//       event.preventDefault();

//       await confirmAndOpenInvitation(
//         invitationCode
//       );
//     };


//   const openCreatedInvitation =
//     async () => {
//       const code =
//         getCreatedInvitationCode();

//       if (!code) {
//         setError(
//           'No invitation code is available.'
//         );

//         return;
//       }

//       await confirmAndOpenInvitation(
//         code
//       );
//     };


//   /* ========================================
//      RENDER
//   ======================================== */

//   return (
//     <div className="dignitary-admin-page">
//       <div className="dignitary-admin-glow dignitary-admin-glow--one" />
//       <div className="dignitary-admin-glow dignitary-admin-glow--two" />


//       <motion.main
//         className="dignitary-admin-card dignitary-admin-card--wide"
//         initial={{
//           opacity:
//             0,

//           y:
//             24,
//         }}
//         animate={{
//           opacity:
//             1,

//           y:
//             0,
//         }}
//         transition={{
//           duration:
//             0.45,
//         }}
//       >
//         <div className="dignitary-admin-lock">
//           VIP / VVIP
//         </div>

//         <span className="dignitary-admin-eyebrow">
//           Private Admin
//         </span>

//         <h1>
//           Dignitary Invitations
//         </h1>

//         <p className="dignitary-admin-intro">
//           Create single invitations with KingsChat usernames,
//           or upload multiple dignitaries and send each invite
//           directly from their KingsChat profile.
//         </p>


//         {/* =====================================
//             ADMIN KEY
//         ===================================== */}

//         <section className="dignitary-shared-admin">
//           <label htmlFor="dignitary-admin-key">
//             Admin Access Key
//           </label>

//           <div className="dignitary-password-wrap">
//             <input
//               id="dignitary-admin-key"
//               type={
//                 showAdminKey
//                   ? 'text'
//                   : 'password'
//               }
//               value={
//                 adminKey
//               }
//               onChange={(
//                 event
//               ) => {
//                 setAdminKey(
//                   event.target.value
//                 );

//                 setError('');
//                 setBulkError('');
//               }}
//               placeholder="Enter your private admin key"
//               autoComplete="off"
//             />

//             <button
//               type="button"
//               onClick={() =>
//                 setShowAdminKey(
//                   (
//                     current
//                   ) =>
//                     !current
//                 )
//               }
//             >
//               {showAdminKey
//                 ? 'Hide'
//                 : 'Show'}
//             </button>
//           </div>
//         </section>


//         {/* =====================================
//             TABS
//         ===================================== */}

//         <div className="dignitary-mode-tabs">
//           <button
//             type="button"
//             className={
//               activeMode ===
//               'single'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'single'
//               );

//               setBulkError('');
//             }}
//           >
//             Single Invitation
//           </button>


//           <button
//             type="button"
//             className={
//               activeMode ===
//               'bulk'
//                 ? 'is-active'
//                 : ''
//             }
//             onClick={() => {
//               setActiveMode(
//                 'bulk'
//               );

//               setError('');
//             }}
//           >
//             Bulk Upload
//           </button>
//         </div>


//         {/* =====================================
//             SINGLE CREATE
//         ===================================== */}

//         {activeMode ===
//           'single' && (
//           <section className="dignitary-mode-panel">
//             {error && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {error}
//               </div>
//             )}


//             {created ? (
//               <motion.div
//                 className="dignitary-created"
//                 initial={{
//                   opacity:
//                     0,

//                   scale:
//                     0.98,
//                 }}
//                 animate={{
//                   opacity:
//                     1,

//                   scale:
//                     1,
//                 }}
//               >
//                 <div className="dignitary-created-check">
//                   ✓
//                 </div>

//                 <span className="dignitary-created-label">
//                   Invitation Created
//                 </span>

//                 <div
//                   className={`dignitary-level-pill dignitary-level-pill--${String(
//                     created.dignitaryLevel ||
//                     'VIP'
//                   ).toLowerCase()}`}
//                 >
//                   {created.dignitaryLevel ||
//                     'VIP'}
//                   {' · '}
//                   {(created.dignitaryLevel ||
//                     'VIP') ===
//                   'VVIP'
//                     ? 'Gold QR'
//                     : 'Purple QR'}
//                 </div>

//                 <h2>
//                   {created.fullName}
//                 </h2>


//                 {getCreatedKcUsername() && (
//                   <div className="dignitary-created-code">
//                     <span>
//                       KingsChat Username
//                     </span>

//                     <strong>
//                       @{getCreatedKcUsername()}
//                     </strong>

//                     <a
//                       href={
//                         getCreatedKingsChatUrl()
//                       }
//                       target="_blank"
//                       rel="noreferrer"
//                     >
//                       Open KingsChat Profile
//                     </a>
//                   </div>
//                 )}


//                 <div className="dignitary-created-code">
//                   <span>
//                     Invitation Code
//                   </span>

//                   <strong>
//                     {getCreatedInvitationCode()}
//                   </strong>

//                   <button
//                     type="button"
//                     className="dignitary-copy-code-button"
//                     onClick={
//                       copyInvitationCode
//                     }
//                   >
//                     {copiedCode
//                       ? 'Code Copied ✓'
//                       : 'Copy Invitation Code'}
//                   </button>
//                 </div>


//                 <div className="dignitary-access-box">
//                   <span>
//                     ACCESS
//                   </span>

//                   <strong>
//                     ✓ Thanksgiving Service
//                   </strong>

//                   <strong>
//                     ✓ Reception / Banquet
//                   </strong>
//                 </div>


//                 <div className="dignitary-link-box">
//                   <span>
//                     Private Invitation Link
//                   </span>

//                   <input
//                     type="text"
//                     value={
//                       getCreatedInvitationLink()
//                     }
//                     readOnly
//                   />


//                   <div className="dignitary-created-actions">
//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationLink
//                       }
//                     >
//                       {copiedLink
//                         ? 'Link Copied ✓'
//                         : 'Copy Invitation Link'}
//                     </button>


//                     <button
//                       type="button"
//                       onClick={
//                         copyInvitationMessage
//                       }
//                     >
//                       {copiedInvite
//                         ? 'Invite Message Copied ✓'
//                         : 'Copy Invite Message'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-send-kingschat-button"
//                       onClick={
//                         sendCreatedInviteOnKingsChat
//                       }
//                       disabled={
//                         !getCreatedKcUsername()
//                       }
//                     >
//                       {sentInvite
//                         ? 'Message Copied · KingsChat Opened ✓'
//                         : 'Send Invite'}
//                     </button>


//                     <button
//                       type="button"
//                       className="dignitary-view-button"
//                       onClick={
//                         openCreatedInvitation
//                       }
//                       disabled={
//                         invitationLookupLoading
//                       }
//                     >
//                       View Invitation
//                     </button>
//                   </div>
//                 </div>


//                 <p>
//                   <strong>
//                     Send Invite
//                   </strong>
//                   {' '}
//                   opens
//                   {' '}
//                   {getCreatedKcUsername()
//                     ? `https://kingschat.online/user/${getCreatedKcUsername()}`
//                     : 'the invitee’s KingsChat profile'}
//                   {' '}
//                   and copies the invitation message to your clipboard.
//                 </p>


//                 <button
//                   type="button"
//                   className="dignitary-secondary-button"
//                   onClick={
//                     createAnother
//                   }
//                 >
//                   Create Another Invitation
//                 </button>
//               </motion.div>
//             ) : (
//               <form
//                 className="dignitary-admin-form"
//                 onSubmit={
//                   handleSubmit
//                 }
//               >
//                 <div className="dignitary-admin-divider">
//                   <span />

//                   <b>
//                     SINGLE DIGNITARY
//                   </b>

//                   <span />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-title">
//                     Title
//                   </label>

//                   <input
//                     id="dignitary-title"
//                     name="title"
//                     type="text"
//                     value={
//                       form.title
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Pastor, Sister, Deacon, Brother..."
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-firstname">
//                     First Name
//                   </label>

//                   <input
//                     id="dignitary-firstname"
//                     name="firstname"
//                     type="text"
//                     value={
//                       form.firstname
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter first name"
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-lastname">
//                     Last Name
//                   </label>

//                   <input
//                     id="dignitary-lastname"
//                     name="lastname"
//                     type="text"
//                     value={
//                       form.lastname
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="Enter last name"
//                     required
//                   />
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-kcusername">
//                     KingsChat Username
//                   </label>

//                   <input
//                     id="dignitary-kcusername"
//                     name="kcusername"
//                     type="text"
//                     value={
//                       form.kcusername
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     placeholder="@smartyk or smartyk"
//                     autoCapitalize="none"
//                     autoCorrect="off"
//                     spellCheck="false"
//                     required
//                   />

//                   <small>
//                     The @ is optional. It is stored without @.
//                   </small>
//                 </div>


//                 <div className="dignitary-admin-field">
//                   <label htmlFor="dignitary-level">
//                     VIP / VVIP
//                   </label>

//                   <select
//                     id="dignitary-level"
//                     name="dignitaryLevel"
//                     value={
//                       form.dignitaryLevel
//                     }
//                     onChange={
//                       handleChange
//                     }
//                     required
//                   >
//                     <option value="VIP">
//                       VIP — Purple QR
//                     </option>

//                     <option value="VVIP">
//                       VVIP — Gold QR
//                     </option>
//                   </select>
//                 </div>


//                 <motion.button
//                   type="submit"
//                   className="dignitary-admin-submit"
//                   disabled={
//                     loading
//                   }
//                   whileHover={
//                     !loading
//                       ? {
//                           scale:
//                             1.01,
//                         }
//                       : {}
//                   }
//                   whileTap={
//                     !loading
//                       ? {
//                           scale:
//                             0.99,
//                         }
//                       : {}
//                   }
//                 >
//                   {loading
//                     ? 'Creating Invitation…'
//                     : 'Create Private Invitation'}
//                 </motion.button>
//               </form>
//             )}
//           </section>
//         )}


//         {/* =====================================
//             BULK UPLOAD
//         ===================================== */}

//         {activeMode ===
//           'bulk' && (
//           <section className="dignitary-mode-panel">
//             <div className="dignitary-bulk-intro">
//               <div>
//                 <span>
//                   EXCEL TEMPLATE
//                 </span>

//                 <h2>
//                   {bulkDignitaryLevel === 'VVIP'
//                     ? 'VVIP — five columns'
//                     : 'VIP — four columns'}
//                 </h2>

//                 <p>
//                   Both templates include
//                   <strong> Title</strong>,
//                   <strong> firstname</strong>,
//                   <strong> lastname</strong> and
//                   <strong> kcusername</strong>.
//                   {bulkDignitaryLevel === 'VVIP' && (
//                     <> The VVIP template also requires a
//                     <strong> Table Name</strong> for each invitee.</>
//                   )}
//                   {' '}The @ in a KingsChat username is optional.
//                   Select the level below before downloading the template.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 className="dignitary-template-button"
//                 onClick={
//                   downloadBulkTemplate
//                 }
//               >
//                 Download Excel Template
//               </button>
//             </div>


//             <div className="dignitary-category-guide">
//               <div className="dignitary-category-guide--vip">
//                 <span>
//                   VIP
//                 </span>

//                 <strong>
//                   Purple QR Code
//                 </strong>
//               </div>

//               <div className="dignitary-category-guide--vvip">
//                 <span>
//                   VVIP
//                 </span>

//                 <strong>
//                   Gold QR Code
//                 </strong>
//               </div>
//             </div>


//             <form
//               className="dignitary-bulk-form"
//               onSubmit={
//                 handleBulkUpload
//               }
//             >
//               <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-bulk-level">
//                   Level for this upload
//                 </label>

//                 <select
//                   id="dignitary-bulk-level"
//                   value={
//                     bulkDignitaryLevel
//                   }
//                   onChange={(
//                     event
//                   ) =>
//                     setBulkDignitaryLevel(
//                       event.target.value
//                     )
//                   }
//                 >
//                   <option value="VIP">
//                     VIP
//                   </option>

//                   <option value="VVIP">
//                     VVIP
//                   </option>
//                 </select>

//                 <small>
//                   This applies to every invitee in the uploaded sheet.
//                 </small>
//               </div>


//               <div className="dignitary-admin-field">
//                 <label htmlFor="dignitary-bulk-file">
//                   Upload Completed Excel File
//                 </label>

//                 <input
//                   id="dignitary-bulk-file"
//                   type="file"
//                   accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//                   onChange={(
//                     event
//                   ) => {
//                     setBulkFile(
//                       event.target
//                         .files?.[0] ||
//                       null
//                     );

//                     setBulkError('');
//                     setBulkRowErrors([]);
//                   }}
//                   required
//                 />

//                 {bulkFile && (
//                   <small>
//                     Selected: {bulkFile.name}
//                   </small>
//                 )}
//               </div>


//               <button
//                 type="submit"
//                 className="dignitary-admin-submit"
//                 disabled={
//                   bulkLoading
//                 }
//               >
//                 {bulkLoading
//                   ? 'Uploading & Creating Invitations…'
//                   : 'Upload & Generate Invitations'}
//               </button>
//             </form>


//             {bulkError && (
//               <div
//                 className="dignitary-admin-alert"
//                 role="alert"
//               >
//                 {bulkError}
//               </div>
//             )}


//             {bulkRowErrors.length >
//               0 && (
//               <div className="dignitary-bulk-row-errors">
//                 <strong>
//                   Fix these rows and upload again:
//                 </strong>

//                 {bulkRowErrors.map(
//                   (
//                     item,
//                     index
//                   ) => (
//                     <p
//                       key={`${item.row}-${index}`}
//                     >
//                       Row {item.row}
//                       {item.kcusername
//                         ? ` — @${normalizeKcUsername(
//                             item.kcusername
//                           )}`
//                         : ''}
//                       {item.fullName
//                         ? ` — ${item.fullName}`
//                         : ''}
//                       : {item.message}
//                     </p>
//                   )
//                 )}
//               </div>
//             )}


//             {bulkResults.length >
//               0 && (
//               <div className="dignitary-bulk-results">
//                 <div className="dignitary-bulk-results-head">
//                   <div>
//                     <span>
//                       IMPORT COMPLETE
//                     </span>

//                     <h2>
//                       {bulkSummary.total} Invitations Created
//                     </h2>
//                   </div>


//                   <button
//                     type="button"
//                     onClick={
//                       copyAllBulkInvites
//                     }
//                   >
//                     {copiedBulkKey ===
//                     'all-invites'
//                       ? 'All Invite Messages Copied ✓'
//                       : 'Copy All Invite Messages'}
//                   </button>


//                   <button
//                     type="button"
//                     onClick={
//                       downloadBulkResults
//                     }
//                   >
//                     Download Results CSV
//                   </button>
//                 </div>


//                 <div className="dignitary-bulk-stats">
//                   <div>
//                     <span>
//                       Total
//                     </span>

//                     <strong>
//                       {bulkSummary.total}
//                     </strong>
//                   </div>

//                   <div className="is-vip">
//                     <span>
//                       VIP
//                     </span>

//                     <strong>
//                       {bulkSummary.VIP}
//                     </strong>
//                   </div>

//                   <div className="is-vvip">
//                     <span>
//                       VVIP
//                     </span>

//                     <strong>
//                       {bulkSummary.VVIP}
//                     </strong>
//                   </div>
//                 </div>


//                 <div className="dignitary-bulk-table-wrap">
//                   <table className="dignitary-bulk-table">
//                     <thead>
//                       <tr>
//                         <th>
//                           Invitee
//                         </th>

//                         <th>
//                           KingsChat
//                         </th>

//                         <th>
//                           VIP/VVIP
//                         </th>

//                         {bulkResults.some((item) => item.dignitaryLevel === 'VVIP') && (
//                           <th>Table Name</th>
//                         )}

//                         <th>
//                           Copy Invite
//                         </th>

//                         <th>
//                           Send Invite
//                         </th>

//                         <th>
//                           Invitation Code
//                         </th>

//                         <th>
//                           Invitation Link
//                         </th>
//                       </tr>
//                     </thead>


//                     <tbody>
//                       {bulkResults.map(
//                         (
//                           item,
//                           index
//                         ) => {
//                           const codeKey =
//                             `code-${index}`;

//                           const linkKey =
//                             `link-${index}`;

//                           const inviteKey =
//                             `invite-${index}`;

//                           const sendKey =
//                             `send-${index}`;

//                           const level =
//                             item.dignitaryLevel ||
//                             'VIP';

//                           const kcusername =
//                             getBulkKcUsername(
//                               item
//                             );

//                           return (
//                             <tr
//                               key={
//                                 item.id ||
//                                 item.invitationCode
//                               }
//                             >
//                               <td>
//                                 <strong>
//                                   {item.fullName}
//                                 </strong>
//                               </td>


//                               <td>
//                                 {kcusername ? (
//                                   <>
//                                     <code>
//                                       @{kcusername}
//                                     </code>

//                                     <a
//                                       href={
//                                         getBulkKingsChatUrl(
//                                           item
//                                         )
//                                       }
//                                       target="_blank"
//                                       rel="noreferrer"
//                                     >
//                                       Open
//                                     </a>
//                                   </>
//                                 ) : (
//                                   <span>
//                                     No username
//                                   </span>
//                                 )}
//                               </td>


//                               <td>
//                                 <span
//                                   className={`dignitary-level-pill dignitary-level-pill--${level.toLowerCase()}`}
//                                 >
//                                   {level}
//                                 </span>
//                               </td>

//                               {bulkResults.some((x) => x.dignitaryLevel === 'VVIP') && (
//                                 <td>{item.tableName || '—'}</td>
//                               )}

//                               <td>
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationMessage(
//                                         item
//                                       ),
//                                       inviteKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   inviteKey
//                                     ? 'Invite Copied ✓'
//                                     : 'Copy Invite'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <button
//                                   type="button"
//                                   className="dignitary-send-kingschat-button"
//                                   disabled={
//                                     !kcusername
//                                   }
//                                   onClick={() =>
//                                     sendBulkInviteOnKingsChat(
//                                       item,
//                                       sendKey
//                                     )
//                                   }
//                                 >
//                                   {sentBulkKey ===
//                                   sendKey
//                                     ? 'Message Copied · Opened ✓'
//                                     : 'Send Invite'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <code>
//                                   {item.invitationCode}
//                                 </code>

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       item.invitationCode,
//                                       codeKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   codeKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Code'}
//                                 </button>
//                               </td>


//                               <td>
//                                 <input
//                                   type="text"
//                                   readOnly
//                                   value={
//                                     getBulkInvitationLink(
//                                       item
//                                     )
//                                   }
//                                 />

//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     copyBulkValue(
//                                       getBulkInvitationLink(
//                                         item
//                                       ),
//                                       linkKey
//                                     )
//                                   }
//                                 >
//                                   {copiedBulkKey ===
//                                   linkKey
//                                     ? 'Copied ✓'
//                                     : 'Copy Link'}
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         }
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}
//           </section>
//         )}


//         {/* =====================================
//             OPEN EXISTING INVITATION
//         ===================================== */}

//         <section className="dignitary-shared-admin">
//           <form
//             onSubmit={
//               handleInvitationLookup
//             }
//           >
//             <label htmlFor="existing-invitation-code">
//               Open Existing Invitation
//             </label>

//             <div className="dignitary-password-wrap">
//               <input
//                 id="existing-invitation-code"
//                 type="text"
//                 value={
//                   invitationCode
//                 }
//                 onChange={(
//                   event
//                 ) => {
//                   setInvitationCode(
//                     event.target.value
//                   );

//                   setInvitationLookupError(
//                     ''
//                   );
//                 }}
//                 placeholder="VIP-... or invitation link"
//               />

//               <button
//                 type="submit"
//                 disabled={
//                   invitationLookupLoading
//                 }
//               >
//                 {invitationLookupLoading
//                   ? 'Opening…'
//                   : 'Open'}
//               </button>
//             </div>
//           </form>

//           {invitationLookupError && (
//             <div
//               className="dignitary-admin-alert"
//               role="alert"
//             >
//               {invitationLookupError}
//             </div>
//           )}
//         </section>
//       </motion.main>
//     </div>
//   );
// }


import React, {
  useMemo,
  useState,
} from 'react';

import {
  motion,
} from 'framer-motion';

import {
  useNavigate,
} from 'react-router-dom';

import * as XLSX
  from 'xlsx';

import './DignitarySuperMin.css';


/* =========================================================
   API / INVITATION URL CONFIGURATION

   - On localhost / 127.0.0.1, requests go to your local API.
   - On a deployed website, requests go to your Render API.
   - REACT_APP_API_URL takes priority when explicitly set.
   - Links copied and sent to invitees use the PUBLIC frontend,
     not localhost, so recipients can open their invitation.

   .env.development example:
      REACT_APP_API_URL=http://localhost:3001
      REACT_APP_INVITATION_BASE_URL=https://celebratingcos.site

   .env.production example:
      REACT_APP_API_URL=https://lsdcnodejs-api.onrender.com
      REACT_APP_INVITATION_BASE_URL=https://celebratingcos.site

   If your local Express server runs on a port other than 3001,
   change REACT_APP_API_URL in .env.development to match it.
   Restart your React dev server after changing .env files.
========================================================= */

const LOCAL_API_URL = 'http://localhost:3001';
const LIVE_API_URL = 'https://lsdcnodejs-api.onrender.com';
const LIVE_FRONTEND_URL = 'https://celebratingcos.site';

const isLocalhost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1', '[::1]'].includes(
    window.location.hostname
  );

// Set REACT_APP_API_URL to override the automatic selection.
const API_URL = String(
  process.env.REACT_APP_API_URL ||
    (isLocalhost
      ? process.env.REACT_APP_LOCAL_API_URL || LOCAL_API_URL
      : process.env.REACT_APP_LIVE_API_URL || LIVE_API_URL)
)
  .trim()
  .replace(/\/+$/, '');

// Public link to share with dignitaries (never a private localhost URL).
const INVITATION_BASE_URL = String(
  process.env.REACT_APP_INVITATION_BASE_URL || LIVE_FRONTEND_URL
)
  .trim()
  .replace(/\/+$/, '');


const initialForm = {
  title: '',
  firstname: '',
  lastname: '',
  kcusername: '',
  dignitaryLevel: 'VIP',
};


/* ==========================================
   HELPERS
========================================== */

const normalizeInvitationCode = (
  value = ''
) => {
  const raw =
    String(
      value ||
      ''
    ).trim();

  if (!raw) {
    return '';
  }

  try {
    if (
      raw.startsWith(
        'http://'
      ) ||
      raw.startsWith(
        'https://'
      )
    ) {
      const url =
        new URL(
          raw
        );

      const parts =
        url.pathname
          .split('/')
          .filter(Boolean);

      const invitationIndex =
        parts.findIndex(
          (part) =>
            part.toLowerCase() ===
            'invitation'
        );

      if (
        invitationIndex !== -1 &&
        parts[
          invitationIndex + 1
        ]
      ) {
        return decodeURIComponent(
          parts[
            invitationIndex + 1
          ]
        );
      }

      return decodeURIComponent(
        parts[
          parts.length - 1
        ] ||
        ''
      );
    }
  } catch {
    // Treat it as a raw invitation code.
  }

  const marker =
    '/invitation/';

  const lowerRaw =
    raw.toLowerCase();

  const markerIndex =
    lowerRaw.indexOf(
      marker
    );

  if (
    markerIndex !== -1
  ) {
    return decodeURIComponent(
      raw
        .slice(
          markerIndex +
            marker.length
        )
        .split('?')[0]
        .split('#')[0]
        .replace(
          /\/+$/,
          ''
        )
    );
  }

  return raw
    .split('?')[0]
    .split('#')[0]
    .replace(
      /\/+$/,
      ''
    );
};


const normalizeKcUsername = (
  value = ''
) =>
  String(
    value ||
    ''
  )
    .trim()
    .replace(
      /^@+/,
      ''
    )
    .trim()
    .toLowerCase();


const buildKingsChatProfileUrl = (
  kcusername = ''
) => {
  const username =
    normalizeKcUsername(
      kcusername
    );

  if (!username) {
    return '';
  }

  return `https://kingschat.online/user/${encodeURIComponent(
    username
  )}`;
};


const copyTextToClipboard =
  async (
    text
  ) => {
    const value =
      String(
        text ||
        ''
      ).trim();

    if (!value) {
      throw new Error(
        'There is nothing to copy.'
      );
    }

    if (
      navigator.clipboard &&
      window.isSecureContext
    ) {
      await navigator.clipboard.writeText(
        value
      );

      return;
    }

    const textarea =
      document.createElement(
        'textarea'
      );

    textarea.value =
      value;

    textarea.setAttribute(
      'readonly',
      ''
    );

    textarea.style.position =
      'fixed';

    textarea.style.left =
      '-9999px';

    textarea.style.opacity =
      '0';

    document.body.appendChild(
      textarea
    );

    textarea.focus();
    textarea.select();

    const copied =
      document.execCommand(
        'copy'
      );

    textarea.remove();

    if (!copied) {
      throw new Error(
        'Copy failed.'
      );
    }
  };


const buildInvitationLink = (
  code,
  fallbackLink = ''
) => {
  const normalizedCode =
    normalizeInvitationCode(
      code ||
      fallbackLink
    );

  if (!normalizedCode) {
    return fallbackLink;
  }

  return `${INVITATION_BASE_URL}/invitation/${encodeURIComponent(
    normalizedCode
  )}`;
};


const formatInviteeSalutation = (
  fullName = ''
) => {
  const name =
    String(
      fullName ||
      ''
    ).trim();

  if (!name) {
    return 'Esteemed Guest';
  }

  if (
    /^esteemed\b/i.test(
      name
    )
  ) {
    return name;
  }

  return `Esteemed ${name}`;
};


const buildInvitationMessage = ({
  fullName,
  invitationLink,
  tableName = '',
  dignitaryLevel = 'VIP',
}) => {
  const salutationName =
    formatInviteeSalutation(
      fullName
    );

  const link =
    String(
      invitationLink ||
      ''
    ).trim();

  if (String(dignitaryLevel).trim().toUpperCase() === 'VVIP') {
    return `SPECIAL ACCESS: BIRTHDAY THANKSGIVING & BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI

Dear ${salutationName},

Greetings in the precious Name of our Lord Jesus Christ.

Further to your invitation to the Birthday Celebration of our Esteemed Chief of Staff, Pastor Bisola Adeyemi, we are pleased to provide your official access details for the Banquet.

Event Details:

Thanksgiving Service:
Bay 4 — 10:00 a.m. prompt

Banquet:
The Angel Court — Immediately after the Thanksgiving Service

Kindly click the link below to access your Banquet Pass and Table Number:

Access Link:
${link}

We look forward to welcoming you and sharing in this special celebration.

Thank you,
The Organising Committee`;
  }

  return `*SPECIAL INVITATION TO THE BIRTHDAY CELEBRATION, THANKSGIVING AND BANQUET OF THE HIGHLY ESTEEMED CHIEF OF STAFF, LOVEWORLD NATION; PASTOR BISOLA ADEYEMI*

Dear ${salutationName},

Greetings in the precious Name of our Lord Jesus Christ.

We are delighted to invite you to the Birthday Celebration of our Highly Esteemed Chief of Staff, Pastor Bisola Adeyemi, scheduled to hold on *Tuesday, 6th October 2026*.

*Event Details:*
*Thanksgiving Service*: Bay 4, 10am prompt

*Banquet*: The Angel Court, Immediately after the Thanksgiving
${tableName ? `*Assigned Table*: ${tableName}\n` : ''}
Kindly click the link below to confirm your attendance, so your SEAT NUMBER can be sent to you.

Link:
${link}

We look forward to warmly welcoming you.

Kind regards,
*The Organising Committee*`;
};


const escapeCsv = (
  value
) =>
  `"${String(
    value ??
    ''
  ).replace(
    /"/g,
    '""'
  )}"`;


/* ==========================================
   MAIN COMPONENT
========================================== */

export default function DignitarySuperMin() {
  const navigate =
    useNavigate();


  /* ========================================
     MAIN MODE
  ======================================== */

  const [
    activeMode,
    setActiveMode,
  ] =
    useState(
      'single'
    );


  /* ========================================
     ADMIN
  ======================================== */

  const [
    adminKey,
    setAdminKey,
  ] =
    useState(
      () =>
        sessionStorage.getItem(
          'birthday_admin_key'
        ) ||
        ''
    );

  const [
    showAdminKey,
    setShowAdminKey,
  ] =
    useState(
      false
    );


  /* ========================================
     SINGLE INVITATION
  ======================================== */

  const [
    form,
    setForm,
  ] =
    useState(
      initialForm
    );

  const [
    loading,
    setLoading,
  ] =
    useState(
      false
    );

  const [
    error,
    setError,
  ] =
    useState(
      ''
    );

  const [
    created,
    setCreated,
  ] =
    useState(
      null
    );

  const [
    copiedLink,
    setCopiedLink,
  ] =
    useState(
      false
    );

  const [
    copiedCode,
    setCopiedCode,
  ] =
    useState(
      false
    );

  const [
    copiedInvite,
    setCopiedInvite,
  ] =
    useState(
      false
    );

  const [
    sentInvite,
    setSentInvite,
  ] =
    useState(
      false
    );


  /* ========================================
     BULK INVITATION
  ======================================== */

  const [
    bulkFile,
    setBulkFile,
  ] =
    useState(
      null
    );

  const [
    bulkDignitaryLevel,
    setBulkDignitaryLevel,
  ] =
    useState(
      'VIP'
    );

  const [
    bulkLoading,
    setBulkLoading,
  ] =
    useState(
      false
    );

  const [
    bulkError,
    setBulkError,
  ] =
    useState(
      ''
    );

  const [
    bulkRowErrors,
    setBulkRowErrors,
  ] =
    useState(
      []
    );

  const [
    bulkResults,
    setBulkResults,
  ] =
    useState(
      []
    );

  const [
    copiedBulkKey,
    setCopiedBulkKey,
  ] =
    useState(
      ''
    );

  const [
    sentBulkKey,
    setSentBulkKey,
  ] =
    useState(
      ''
    );


  /* ========================================
     OPEN EXISTING INVITATION
  ======================================== */

  const [
    invitationCode,
    setInvitationCode,
  ] =
    useState(
      ''
    );

  const [
    invitationLookupLoading,
    setInvitationLookupLoading,
  ] =
    useState(
      false
    );

  const [
    invitationLookupError,
    setInvitationLookupError,
  ] =
    useState(
      ''
    );


  /* ========================================
     SUMMARY
  ======================================== */

  const bulkSummary =
    useMemo(
      () => ({
        total:
          bulkResults.length,

        VIP:
          bulkResults.filter(
            (
              item
            ) =>
              item.dignitaryLevel ===
              'VIP'
          ).length,

        VVIP:
          bulkResults.filter(
            (
              item
            ) =>
              item.dignitaryLevel ===
              'VVIP'
          ).length,
      }),
      [
        bulkResults,
      ]
    );


  /* ========================================
     ADMIN KEY
  ======================================== */

  const ensureAdminKey =
    () => {
      const key =
        adminKey.trim();

      if (!key) {
        return '';
      }

      sessionStorage.setItem(
        'birthday_admin_key',
        key
      );

      return key;
    };


  /* ========================================
     SINGLE FORM
  ======================================== */

  const handleChange =
    (
      event
    ) => {
      const {
        name,
        value,
      } =
        event.target;

      setForm(
        (
          current
        ) => ({
          ...current,

          [name]:
            value,
        })
      );

      if (error) {
        setError('');
      }
    };


  const handleSubmit =
    async (
      event
    ) => {
      event.preventDefault();

      const key =
        ensureAdminKey();

      if (!key) {
        setError(
          'Enter your admin access key.'
        );

        return;
      }

      const title =
        String(
          form.title ||
          ''
        ).trim();

      const firstname =
        String(
          form.firstname ||
          ''
        ).trim();

      const lastname =
        String(
          form.lastname ||
          ''
        ).trim();

      const kcusername =
        normalizeKcUsername(
          form.kcusername
        );

      if (
        !title ||
        !firstname ||
        !lastname ||
        !kcusername
      ) {
        setError(
          'Title, firstname, lastname and KingsChat username are required.'
        );

        return;
      }

      if (
        ![
          'VIP',
          'VVIP',
        ].includes(
          form.dignitaryLevel
        )
      ) {
        setError(
          'Select VIP or VVIP.'
        );

        return;
      }

      setLoading(
        true
      );

      setError('');
      setCreated(null);
      setCopiedLink(false);
      setCopiedCode(false);
      setCopiedInvite(false);
      setSentInvite(false);

      try {
        const response =
          await fetch(
            `${API_URL}/api/birthday/dignitary/create`,
            {
              method:
                'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'x-admin-key':
                  key,
              },

              body:
                JSON.stringify({
                  title,
                  firstname,
                  lastname,

                  /*
                   * We always send this without @.
                   */
                  kcusername,

                  dignitaryLevel:
                    form.dignitaryLevel,
                }),
            }
          );

        let result =
          {};

        try {
          result =
            await response.json();
        } catch {
          result =
            {};
        }

        if (
          !response.ok ||
          !result.success
        ) {
          throw new Error(
            result.message ||
              'Unable to create this dignitary invitation.'
          );
        }

        setCreated(
          result.data
        );

        setForm(
          initialForm
        );

        const newCode =
          normalizeInvitationCode(
            result.data
              ?.invitationCode ||
              result.data
                ?.invitationLink ||
              ''
          );

        if (newCode) {
          setInvitationCode(
            newCode
          );
        }
      } catch (
        err
      ) {
        setError(
          err.message ||
            'Unable to create this dignitary invitation.'
        );
      } finally {
        setLoading(
          false
        );
      }
    };


  const getCreatedInvitationCode =
    () =>
      normalizeInvitationCode(
        created
          ?.invitationCode ||
        created
          ?.invitationLink ||
        ''
      );


  const getCreatedInvitationLink =
    () =>
      buildInvitationLink(
        created
          ?.invitationCode,

        created
          ?.invitationLink ||
        ''
      );


  const getCreatedInvitationMessage =
    () =>
      buildInvitationMessage({
        fullName:
          created
            ?.fullName ||
          '',

        invitationLink:
          getCreatedInvitationLink(),

        dignitaryLevel: created?.dignitaryLevel || 'VIP',
      });


  const getCreatedKcUsername =
    () =>
      normalizeKcUsername(
        created
          ?.kcusername ||
        created
          ?.kc_username ||
        ''
      );


  const getCreatedKingsChatUrl =
    () =>
      buildKingsChatProfileUrl(
        getCreatedKcUsername()
      );


  const copyInvitationMessage =
    async () => {
      const message =
        getCreatedInvitationMessage();

      if (!message) {
        setError(
          'No invitation message is available.'
        );

        return;
      }

      try {
        await copyTextToClipboard(
          message
        );

        setCopiedInvite(
          true
        );

        setTimeout(
          () =>
            setCopiedInvite(
              false
            ),
          1800
        );
      } catch {
        setError(
          'Could not copy the invitation message.'
        );
      }
    };


  /*
   * SEND INVITE:
   *
   * 1. Opens:
   *    https://kingschat.online/user/{kcusername}
   *
   * 2. Copies the exact invitation message used by
   *    "Copy Invite Message".
   *
   * You can then paste the copied message to the invitee
   * inside KingsChat.
   */
  const sendCreatedInviteOnKingsChat =
    async () => {
      const profileUrl =
        getCreatedKingsChatUrl();

      if (!profileUrl) {
        setError(
          'No KingsChat username is available for this invitee.'
        );

        return;
      }

      /*
       * Open immediately so the browser treats this as
       * a direct user-click and does not block the new tab.
       */
      window.open(
        profileUrl,
        '_blank',
        'noopener,noreferrer'
      );

      try {
        await copyTextToClipboard(
          getCreatedInvitationMessage()
        );

        setSentInvite(
          true
        );

        setCopiedInvite(
          true
        );

        setTimeout(
          () => {
            setSentInvite(
              false
            );

            setCopiedInvite(
              false
            );
          },
          2200
        );
      } catch {
        setError(
          'KingsChat was opened, but the invitation message could not be copied automatically. Click "Copy Invite Message" and paste it in KingsChat.'
        );
      }
    };


  const copyInvitationLink =
    async () => {
      const link =
        getCreatedInvitationLink();

      if (!link) {
        setError(
          'No invitation link is available.'
        );

        return;
      }

      try {
        await copyTextToClipboard(
          link
        );

        setCopiedLink(
          true
        );

        setTimeout(
          () =>
            setCopiedLink(
              false
            ),
          1600
        );
      } catch {
        setError(
          'Could not copy the invitation link.'
        );
      }
    };


  const copyInvitationCode =
    async () => {
      const code =
        getCreatedInvitationCode();

      if (!code) {
        setError(
          'No invitation code is available.'
        );

        return;
      }

      try {
        await copyTextToClipboard(
          code
        );

        setCopiedCode(
          true
        );

        setTimeout(
          () =>
            setCopiedCode(
              false
            ),
          1600
        );
      } catch {
        setError(
          'Could not copy the invitation code.'
        );
      }
    };


  const createAnother =
    () => {
      setCreated(
        null
      );

      setError('');
      setCopiedCode(false);
      setCopiedLink(false);
      setCopiedInvite(false);
      setSentInvite(false);
    };


  /* ========================================
     DOWNLOAD BULK TEMPLATE
  ======================================== */

  const downloadBulkTemplate = () => {
    const isVvip = bulkDignitaryLevel === 'VVIP';

    const headers = [
      'Title',
      'firstname',
      'lastname',
      'kcusername',
      ...(isVvip ? ['Table Name'] : []),
    ];

    const sheet = XLSX.utils.aoa_to_sheet([headers]);
    sheet['!cols'] = [
      { wch: 20 },
      { wch: 25 },
      { wch: 25 },
      { wch: 30 },
      ...(isVvip ? [{ wch: 30 }] : []),
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      sheet,
      'Dignitary Upload'
    );
    XLSX.writeFile(
      workbook,
      `COS_${bulkDignitaryLevel}_Dignitary_Upload_Template.xlsx`
    );
  };


  /* ========================================
     BULK UPLOAD
  ======================================== */

  const handleBulkUpload =
    async (
      event
    ) => {
      event.preventDefault();

      const key =
        ensureAdminKey();

      if (!key) {
        setBulkError(
          'Enter your admin access key.'
        );

        return;
      }

      if (!bulkFile) {
        setBulkError(
          'Choose the completed Excel file.'
        );

        return;
      }

      if (
        !/\.xlsx$/i.test(
          bulkFile.name
        )
      ) {
        setBulkError(
          'Only .xlsx Excel files are allowed.'
        );

        return;
      }

      setBulkLoading(
        true
      );

      setBulkError('');
      setBulkRowErrors([]);
      setBulkResults([]);
      setCopiedBulkKey('');
      setSentBulkKey('');

      try {
        const formData =
          new FormData();

        formData.append(
          'file',
          bulkFile
        );

        /*
         * Excel stays four columns.
         * The selected level applies to the whole batch.
         */
        formData.append(
          'dignitaryLevel',
          bulkDignitaryLevel
        );

        const response =
          await fetch(
            `${API_URL}/api/birthday/admin/dignitaries/bulk-upload`,
            {
              method:
                'POST',

              /*
               * Do not manually set Content-Type for FormData.
               */
              headers: {
                'x-admin-key':
                  key,
              },

              body:
                formData,
            }
          );

        let result =
          {};

        try {
          result =
            await response.json();
        } catch {
          result =
            {};
        }

        if (
          !response.ok ||
          !result.success
        ) {
          if (
            Array.isArray(
              result.errors
            )
          ) {
            setBulkRowErrors(
              result.errors
            );
          }

          throw new Error(
            result.message ||
              'Unable to upload dignitaries.'
          );
        }

        setBulkResults(
          Array.isArray(
            result.data
          )
            ? result.data
            : []
        );

        setBulkFile(
          null
        );

        const fileInput =
          document.getElementById(
            'dignitary-bulk-file'
          );

        if (
          fileInput
        ) {
          fileInput.value =
            '';
        }
      } catch (
        err
      ) {
        setBulkError(
          err.message ||
            'Unable to upload dignitaries.'
        );
      } finally {
        setBulkLoading(
          false
        );
      }
    };


  const copyBulkValue =
    async (
      value,
      key
    ) => {
      try {
        await copyTextToClipboard(
          value
        );

        setCopiedBulkKey(
          key
        );

        setTimeout(
          () =>
            setCopiedBulkKey(
              ''
            ),
          1400
        );
      } catch {
        setBulkError(
          'Unable to copy automatically.'
        );
      }
    };


  const getBulkInvitationLink =
    (
      item
    ) =>
      buildInvitationLink(
        item
          ?.invitationCode,

        item
          ?.invitationLink ||
        ''
      );


  const getBulkInvitationMessage =
    (
      item
    ) =>
      buildInvitationMessage({
        fullName:
          item
            ?.fullName ||
          '',

        invitationLink:
          getBulkInvitationLink(
            item
          ),
        dignitaryLevel: item?.dignitaryLevel || 'VIP',

        tableName: item?.dignitaryLevel === 'VVIP'
          ? String(item?.tableName || '').trim()
          : '',
      });


  const getBulkKcUsername =
    (
      item
    ) =>
      normalizeKcUsername(
        item
          ?.kcusername ||
        item
          ?.kc_username ||
        ''
      );


  const getBulkKingsChatUrl =
    (
      item
    ) =>
      buildKingsChatProfileUrl(
        getBulkKcUsername(
          item
        )
      );


  /*
   * Per-invitee bulk SEND INVITE.
   */
  const sendBulkInviteOnKingsChat =
    async (
      item,
      key
    ) => {
      const profileUrl =
        getBulkKingsChatUrl(
          item
        );

      if (!profileUrl) {
        setBulkError(
          `No KingsChat username is available for ${item?.fullName || 'this invitee'}.`
        );

        return;
      }

      window.open(
        profileUrl,
        '_blank',
        'noopener,noreferrer'
      );

      try {
        await copyTextToClipboard(
          getBulkInvitationMessage(
            item
          )
        );

        setSentBulkKey(
          key
        );

        setCopiedBulkKey(
          key
        );

        setTimeout(
          () => {
            setSentBulkKey(
              ''
            );

            setCopiedBulkKey(
              ''
            );
          },
          2200
        );
      } catch {
        setBulkError(
          'KingsChat was opened, but the invitation message could not be copied automatically. Copy the invite manually and paste it in KingsChat.'
        );
      }
    };


  const copyAllBulkInvites =
    async () => {
      if (
        bulkResults.length ===
        0
      ) {
        setBulkError(
          'There are no generated invitations to copy.'
        );

        return;
      }

      const allMessages =
        bulkResults
          .map(
            (
              item
            ) =>
              getBulkInvitationMessage(
                item
              )
          )
          .join(
            '\n\n------------------------------\n\n'
          );

      await copyBulkValue(
        allMessages,
        'all-invites'
      );
    };


  const downloadBulkResults =
    () => {
      if (
        bulkResults.length ===
        0
      ) {
        return;
      }

      const rows = [
        [
          'Title',
          'firstname',
          'lastname',
          'kcusername',
          'VIP/VVIP',
          ...(bulkResults.some((item) => item.dignitaryLevel === 'VVIP')
            ? ['Table Name'] : []),
          'Invitation Code',
          'Invitation Link',
          'KingsChat Profile',
          'Invitation Message',
        ],

        ...bulkResults.map(
          (
            item
          ) => [
            item.title ||
              '',

            item.firstname ||
              '',

            item.lastname ||
              '',

            getBulkKcUsername(
              item
            ),

            item.dignitaryLevel ||
              'VIP',

            ...(bulkResults.some((x) => x.dignitaryLevel === 'VVIP')
              ? [item.tableName || ''] : []),

            item.invitationCode,

            getBulkInvitationLink(
              item
            ),

            getBulkKingsChatUrl(
              item
            ),

            getBulkInvitationMessage(
              item
            ),
          ]
        ),
      ];

      const csv =
        rows
          .map(
            (
              row
            ) =>
              row
                .map(
                  escapeCsv
                )
                .join(',')
          )
          .join(
            '\r\n'
          );

      const blob =
        new Blob(
          [
            csv,
          ],
          {
            type:
              'text/csv;charset=utf-8;',
          }
        );

      const url =
        URL.createObjectURL(
          blob
        );

      const anchor =
        document.createElement(
          'a'
        );

      anchor.href =
        url;

      anchor.download =
        'COS_Dignitary_Invitation_Results.csv';

      document.body.appendChild(
        anchor
      );

      anchor.click();
      anchor.remove();

      URL.revokeObjectURL(
        url
      );
    };


  /* ========================================
     OPEN EXISTING INVITATION
  ======================================== */

  const confirmAndOpenInvitation =
    async (
      rawCode
    ) => {
      const code =
        normalizeInvitationCode(
          rawCode
        );

      if (!code) {
        setInvitationLookupError(
          'Enter a valid VIP or VVIP invitation code.'
        );

        return;
      }

      setInvitationLookupLoading(
        true
      );

      setInvitationLookupError(
        ''
      );

      try {
        const response =
          await fetch(
            `${API_URL}/api/birthday/invitation/${encodeURIComponent(
              code
            )}`
          );

        let result =
          {};

        try {
          result =
            await response.json();
        } catch {
          result =
            {};
        }

        if (
          !response.ok ||
          !result.success
        ) {
          throw new Error(
            result.message ||
              'No invitation was found with that code.'
          );
        }

        navigate(
          `/invitation/${encodeURIComponent(
            code
          )}`
        );
      } catch (
        err
      ) {
        setInvitationLookupError(
          err.message ||
            'Unable to confirm this invitation.'
        );
      } finally {
        setInvitationLookupLoading(
          false
        );
      }
    };


  const handleInvitationLookup =
    async (
      event
    ) => {
      event.preventDefault();

      await confirmAndOpenInvitation(
        invitationCode
      );
    };


  const openCreatedInvitation =
    async () => {
      const code =
        getCreatedInvitationCode();

      if (!code) {
        setError(
          'No invitation code is available.'
        );

        return;
      }

      await confirmAndOpenInvitation(
        code
      );
    };


  /* ========================================
     RENDER
  ======================================== */

  return (
    <div className="dignitary-admin-page">
      <div className="dignitary-admin-glow dignitary-admin-glow--one" />
      <div className="dignitary-admin-glow dignitary-admin-glow--two" />


      <motion.main
        className="dignitary-admin-card dignitary-admin-card--wide"
        initial={{
          opacity:
            0,

          y:
            24,
        }}
        animate={{
          opacity:
            1,

          y:
            0,
        }}
        transition={{
          duration:
            0.45,
        }}
      >
        <div className="dignitary-admin-lock">
          VIP / VVIP
        </div>

        <span className="dignitary-admin-eyebrow">
          Private Admin
        </span>

        <h1>
          Dignitary Invitations
        </h1>

        <p className="dignitary-admin-intro">
          Create single invitations with KingsChat usernames,
          or upload multiple dignitaries and send each invite
          directly from their KingsChat profile.
        </p>


        {/* =====================================
            ADMIN KEY
        ===================================== */}

        <section className="dignitary-shared-admin">
          <label htmlFor="dignitary-admin-key">
            Admin Access Key
          </label>

          <div className="dignitary-password-wrap">
            <input
              id="dignitary-admin-key"
              type={
                showAdminKey
                  ? 'text'
                  : 'password'
              }
              value={
                adminKey
              }
              onChange={(
                event
              ) => {
                setAdminKey(
                  event.target.value
                );

                setError('');
                setBulkError('');
              }}
              placeholder="Enter your private admin key"
              autoComplete="off"
            />

            <button
              type="button"
              onClick={() =>
                setShowAdminKey(
                  (
                    current
                  ) =>
                    !current
                )
              }
            >
              {showAdminKey
                ? 'Hide'
                : 'Show'}
            </button>
          </div>
        </section>


        {/* =====================================
            TABS
        ===================================== */}

        <div className="dignitary-mode-tabs">
          <button
            type="button"
            className={
              activeMode ===
              'single'
                ? 'is-active'
                : ''
            }
            onClick={() => {
              setActiveMode(
                'single'
              );

              setBulkError('');
            }}
          >
            Single Invitation
          </button>


          <button
            type="button"
            className={
              activeMode ===
              'bulk'
                ? 'is-active'
                : ''
            }
            onClick={() => {
              setActiveMode(
                'bulk'
              );

              setError('');
            }}
          >
            Bulk Upload
          </button>
        </div>


        {/* =====================================
            SINGLE CREATE
        ===================================== */}

        {activeMode ===
          'single' && (
          <section className="dignitary-mode-panel">
            {error && (
              <div
                className="dignitary-admin-alert"
                role="alert"
              >
                {error}
              </div>
            )}


            {created ? (
              <motion.div
                className="dignitary-created"
                initial={{
                  opacity:
                    0,

                  scale:
                    0.98,
                }}
                animate={{
                  opacity:
                    1,

                  scale:
                    1,
                }}
              >
                <div className="dignitary-created-check">
                  ✓
                </div>

                <span className="dignitary-created-label">
                  Invitation Created
                </span>

                <div
                  className={`dignitary-level-pill dignitary-level-pill--${String(
                    created.dignitaryLevel ||
                    'VIP'
                  ).toLowerCase()}`}
                >
                  {created.dignitaryLevel ||
                    'VIP'}
                  {' · '}
                  {(created.dignitaryLevel ||
                    'VIP') ===
                  'VVIP'
                    ? 'Gold QR'
                    : 'Purple QR'}
                </div>

                <h2>
                  {created.fullName}
                </h2>


                {getCreatedKcUsername() && (
                  <div className="dignitary-created-code">
                    <span>
                      KingsChat Username
                    </span>

                    <strong>
                      @{getCreatedKcUsername()}
                    </strong>

                    <a
                      href={
                        getCreatedKingsChatUrl()
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open KingsChat Profile
                    </a>
                  </div>
                )}


                <div className="dignitary-created-code">
                  <span>
                    Invitation Code
                  </span>

                  <strong>
                    {getCreatedInvitationCode()}
                  </strong>

                  <button
                    type="button"
                    className="dignitary-copy-code-button"
                    onClick={
                      copyInvitationCode
                    }
                  >
                    {copiedCode
                      ? 'Code Copied ✓'
                      : 'Copy Invitation Code'}
                  </button>
                </div>


                <div className="dignitary-access-box">
                  <span>
                    ACCESS
                  </span>

                  <strong>
                    ✓ Thanksgiving Service
                  </strong>

                  <strong>
                    ✓ Reception / Banquet
                  </strong>
                </div>


                <div className="dignitary-link-box">
                  <span>
                    Private Invitation Link
                  </span>

                  <input
                    type="text"
                    value={
                      getCreatedInvitationLink()
                    }
                    readOnly
                  />


                  <div className="dignitary-created-actions">
                    <button
                      type="button"
                      onClick={
                        copyInvitationLink
                      }
                    >
                      {copiedLink
                        ? 'Link Copied ✓'
                        : 'Copy Invitation Link'}
                    </button>


                    <button
                      type="button"
                      onClick={
                        copyInvitationMessage
                      }
                    >
                      {copiedInvite
                        ? 'Invite Message Copied ✓'
                        : 'Copy Invite Message'}
                    </button>


                    <button
                      type="button"
                      className="dignitary-send-kingschat-button"
                      onClick={
                        sendCreatedInviteOnKingsChat
                      }
                      disabled={
                        !getCreatedKcUsername()
                      }
                    >
                      {sentInvite
                        ? 'Message Copied · KingsChat Opened ✓'
                        : 'Send Invite'}
                    </button>


                    <button
                      type="button"
                      className="dignitary-view-button"
                      onClick={
                        openCreatedInvitation
                      }
                      disabled={
                        invitationLookupLoading
                      }
                    >
                      View Invitation
                    </button>
                  </div>
                </div>


                <p>
                  <strong>
                    Send Invite
                  </strong>
                  {' '}
                  opens
                  {' '}
                  {getCreatedKcUsername()
                    ? `https://kingschat.online/user/${getCreatedKcUsername()}`
                    : 'the invitee’s KingsChat profile'}
                  {' '}
                  and copies the invitation message to your clipboard.
                </p>


                <button
                  type="button"
                  className="dignitary-secondary-button"
                  onClick={
                    createAnother
                  }
                >
                  Create Another Invitation
                </button>
              </motion.div>
            ) : (
              <form
                className="dignitary-admin-form"
                onSubmit={
                  handleSubmit
                }
              >
                <div className="dignitary-admin-divider">
                  <span />

                  <b>
                    SINGLE DIGNITARY
                  </b>

                  <span />
                </div>


                <div className="dignitary-admin-field">
                  <label htmlFor="dignitary-title">
                    Title
                  </label>

                  <input
                    id="dignitary-title"
                    name="title"
                    type="text"
                    value={
                      form.title
                    }
                    onChange={
                      handleChange
                    }
                    placeholder="Pastor, Sister, Deacon, Brother..."
                    required
                  />
                </div>


                <div className="dignitary-admin-field">
                  <label htmlFor="dignitary-firstname">
                    First Name
                  </label>

                  <input
                    id="dignitary-firstname"
                    name="firstname"
                    type="text"
                    value={
                      form.firstname
                    }
                    onChange={
                      handleChange
                    }
                    placeholder="Enter first name"
                    required
                  />
                </div>


                <div className="dignitary-admin-field">
                  <label htmlFor="dignitary-lastname">
                    Last Name
                  </label>

                  <input
                    id="dignitary-lastname"
                    name="lastname"
                    type="text"
                    value={
                      form.lastname
                    }
                    onChange={
                      handleChange
                    }
                    placeholder="Enter last name"
                    required
                  />
                </div>


                <div className="dignitary-admin-field">
                  <label htmlFor="dignitary-kcusername">
                    KingsChat Username
                  </label>

                  <input
                    id="dignitary-kcusername"
                    name="kcusername"
                    type="text"
                    value={
                      form.kcusername
                    }
                    onChange={
                      handleChange
                    }
                    placeholder="@smartyk or smartyk"
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck="false"
                    required
                  />

                  <small>
                    The @ is optional. It is stored without @.
                  </small>
                </div>


                <div className="dignitary-admin-field">
                  <label htmlFor="dignitary-level">
                    VIP / VVIP
                  </label>

                  <select
                    id="dignitary-level"
                    name="dignitaryLevel"
                    value={
                      form.dignitaryLevel
                    }
                    onChange={
                      handleChange
                    }
                    required
                  >
                    <option value="VIP">
                      VIP — Purple QR
                    </option>

                    <option value="VVIP">
                      VVIP — Gold QR
                    </option>
                  </select>
                </div>


                <motion.button
                  type="submit"
                  className="dignitary-admin-submit"
                  disabled={
                    loading
                  }
                  whileHover={
                    !loading
                      ? {
                          scale:
                            1.01,
                        }
                      : {}
                  }
                  whileTap={
                    !loading
                      ? {
                          scale:
                            0.99,
                        }
                      : {}
                  }
                >
                  {loading
                    ? 'Creating Invitation…'
                    : 'Create Private Invitation'}
                </motion.button>
              </form>
            )}
          </section>
        )}


        {/* =====================================
            BULK UPLOAD
        ===================================== */}

        {activeMode ===
          'bulk' && (
          <section className="dignitary-mode-panel">
            <div className="dignitary-bulk-intro">
              <div>
                <span>
                  EXCEL TEMPLATE
                </span>

                <h2>
                  {bulkDignitaryLevel === 'VVIP'
                    ? 'VVIP — five columns'
                    : 'VIP — four columns'}
                </h2>

                <p>
                  Both templates include
                  <strong> Title</strong>,
                  <strong> firstname</strong>,
                  <strong> lastname</strong> and
                  <strong> kcusername</strong>.
                  {bulkDignitaryLevel === 'VVIP' && (
                    <> The VVIP template also requires a
                    <strong> Table Name</strong> for each invitee.</>
                  )}
                  {' '}The @ in a KingsChat username is optional.
                  Select the level below before downloading the template.
                </p>
              </div>

              <button
                type="button"
                className="dignitary-template-button"
                onClick={
                  downloadBulkTemplate
                }
              >
                Download Excel Template
              </button>
            </div>


            <div className="dignitary-category-guide">
              <div className="dignitary-category-guide--vip">
                <span>
                  VIP
                </span>

                <strong>
                  Purple QR Code
                </strong>
              </div>

              <div className="dignitary-category-guide--vvip">
                <span>
                  VVIP
                </span>

                <strong>
                  Gold QR Code
                </strong>
              </div>
            </div>


            <form
              className="dignitary-bulk-form"
              onSubmit={
                handleBulkUpload
              }
            >
              <div className="dignitary-admin-field">
                <label htmlFor="dignitary-bulk-level">
                  Level for this upload
                </label>

                <select
                  id="dignitary-bulk-level"
                  value={
                    bulkDignitaryLevel
                  }
                  onChange={(
                    event
                  ) =>
                    setBulkDignitaryLevel(
                      event.target.value
                    )
                  }
                >
                  <option value="VIP">
                    VIP
                  </option>

                  <option value="VVIP">
                    VVIP
                  </option>
                </select>

                <small>
                  This applies to every invitee in the uploaded sheet.
                </small>
              </div>


              <div className="dignitary-admin-field">
                <label htmlFor="dignitary-bulk-file">
                  Upload Completed Excel File
                </label>

                <input
                  id="dignitary-bulk-file"
                  type="file"
                  accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  onChange={(
                    event
                  ) => {
                    setBulkFile(
                      event.target
                        .files?.[0] ||
                      null
                    );

                    setBulkError('');
                    setBulkRowErrors([]);
                  }}
                  required
                />

                {bulkFile && (
                  <small>
                    Selected: {bulkFile.name}
                  </small>
                )}
              </div>


              <button
                type="submit"
                className="dignitary-admin-submit"
                disabled={
                  bulkLoading
                }
              >
                {bulkLoading
                  ? 'Uploading & Creating Invitations…'
                  : 'Upload & Generate Invitations'}
              </button>
            </form>


            {bulkError && (
              <div
                className="dignitary-admin-alert"
                role="alert"
              >
                {bulkError}
              </div>
            )}


            {bulkRowErrors.length >
              0 && (
              <div className="dignitary-bulk-row-errors">
                <strong>
                  Fix these rows and upload again:
                </strong>

                {bulkRowErrors.map(
                  (
                    item,
                    index
                  ) => (
                    <p
                      key={`${item.row}-${index}`}
                    >
                      Row {item.row}
                      {item.kcusername
                        ? ` — @${normalizeKcUsername(
                            item.kcusername
                          )}`
                        : ''}
                      {item.fullName
                        ? ` — ${item.fullName}`
                        : ''}
                      : {item.message}
                    </p>
                  )
                )}
              </div>
            )}


            {bulkResults.length >
              0 && (
              <div className="dignitary-bulk-results">
                <div className="dignitary-bulk-results-head">
                  <div>
                    <span>
                      IMPORT COMPLETE
                    </span>

                    <h2>
                      {bulkSummary.total} Invitations Created
                    </h2>
                  </div>


                  <button
                    type="button"
                    onClick={
                      copyAllBulkInvites
                    }
                  >
                    {copiedBulkKey ===
                    'all-invites'
                      ? 'All Invite Messages Copied ✓'
                      : 'Copy All Invite Messages'}
                  </button>


                  <button
                    type="button"
                    onClick={
                      downloadBulkResults
                    }
                  >
                    Download Results CSV
                  </button>
                </div>


                <div className="dignitary-bulk-stats">
                  <div>
                    <span>
                      Total
                    </span>

                    <strong>
                      {bulkSummary.total}
                    </strong>
                  </div>

                  <div className="is-vip">
                    <span>
                      VIP
                    </span>

                    <strong>
                      {bulkSummary.VIP}
                    </strong>
                  </div>

                  <div className="is-vvip">
                    <span>
                      VVIP
                    </span>

                    <strong>
                      {bulkSummary.VVIP}
                    </strong>
                  </div>
                </div>


                <div className="dignitary-bulk-table-wrap">
                  <table className="dignitary-bulk-table">
                    <thead>
                      <tr>
                        <th>
                          Invitee
                        </th>

                        <th>
                          KingsChat
                        </th>

                        <th>
                          VIP/VVIP
                        </th>

                        {bulkResults.some((item) => item.dignitaryLevel === 'VVIP') && (
                          <th>Table Name</th>
                        )}

                        <th>
                          Copy Invite
                        </th>

                        <th>
                          Send Invite
                        </th>

                        <th>
                          Invitation Code
                        </th>

                        <th>
                          Invitation Link
                        </th>
                      </tr>
                    </thead>


                    <tbody>
                      {bulkResults.map(
                        (
                          item,
                          index
                        ) => {
                          const codeKey =
                            `code-${index}`;

                          const linkKey =
                            `link-${index}`;

                          const inviteKey =
                            `invite-${index}`;

                          const sendKey =
                            `send-${index}`;

                          const level =
                            item.dignitaryLevel ||
                            'VIP';

                          const kcusername =
                            getBulkKcUsername(
                              item
                            );

                          return (
                            <tr
                              key={
                                item.id ||
                                item.invitationCode
                              }
                            >
                              <td>
                                <strong>
                                  {item.fullName}
                                </strong>
                              </td>


                              <td>
                                {kcusername ? (
                                  <>
                                    <code>
                                      @{kcusername}
                                    </code>

                                    <a
                                      href={
                                        getBulkKingsChatUrl(
                                          item
                                        )
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      Open
                                    </a>
                                  </>
                                ) : (
                                  <span>
                                    No username
                                  </span>
                                )}
                              </td>


                              <td>
                                <span
                                  className={`dignitary-level-pill dignitary-level-pill--${level.toLowerCase()}`}
                                >
                                  {level}
                                </span>
                              </td>

                              {bulkResults.some((x) => x.dignitaryLevel === 'VVIP') && (
                                <td>{item.tableName || '—'}</td>
                              )}

                              <td>
                                <button
                                  type="button"
                                  onClick={() =>
                                    copyBulkValue(
                                      getBulkInvitationMessage(
                                        item
                                      ),
                                      inviteKey
                                    )
                                  }
                                >
                                  {copiedBulkKey ===
                                  inviteKey
                                    ? 'Invite Copied ✓'
                                    : 'Copy Invite'}
                                </button>
                              </td>


                              <td>
                                <button
                                  type="button"
                                  className="dignitary-send-kingschat-button"
                                  disabled={
                                    !kcusername
                                  }
                                  onClick={() =>
                                    sendBulkInviteOnKingsChat(
                                      item,
                                      sendKey
                                    )
                                  }
                                >
                                  {sentBulkKey ===
                                  sendKey
                                    ? 'Message Copied · Opened ✓'
                                    : 'Send Invite'}
                                </button>
                              </td>


                              <td>
                                <code>
                                  {item.invitationCode}
                                </code>

                                <button
                                  type="button"
                                  onClick={() =>
                                    copyBulkValue(
                                      item.invitationCode,
                                      codeKey
                                    )
                                  }
                                >
                                  {copiedBulkKey ===
                                  codeKey
                                    ? 'Copied ✓'
                                    : 'Copy Code'}
                                </button>
                              </td>


                              <td>
                                <input
                                  type="text"
                                  readOnly
                                  value={
                                    getBulkInvitationLink(
                                      item
                                    )
                                  }
                                />

                                <button
                                  type="button"
                                  onClick={() =>
                                    copyBulkValue(
                                      getBulkInvitationLink(
                                        item
                                      ),
                                      linkKey
                                    )
                                  }
                                >
                                  {copiedBulkKey ===
                                  linkKey
                                    ? 'Copied ✓'
                                    : 'Copy Link'}
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </section>
        )}


        {/* =====================================
            OPEN EXISTING INVITATION
        ===================================== */}

        <section className="dignitary-shared-admin">
          <form
            onSubmit={
              handleInvitationLookup
            }
          >
            <label htmlFor="existing-invitation-code">
              Open Existing Invitation
            </label>

            <div className="dignitary-password-wrap">
              <input
                id="existing-invitation-code"
                type="text"
                value={
                  invitationCode
                }
                onChange={(
                  event
                ) => {
                  setInvitationCode(
                    event.target.value
                  );

                  setInvitationLookupError(
                    ''
                  );
                }}
                placeholder="VIP-... or invitation link"
              />

              <button
                type="submit"
                disabled={
                  invitationLookupLoading
                }
              >
                {invitationLookupLoading
                  ? 'Opening…'
                  : 'Open'}
              </button>
            </div>
          </form>

          {invitationLookupError && (
            <div
              className="dignitary-admin-alert"
              role="alert"
            >
              {invitationLookupError}
            </div>
          )}
        </section>
      </motion.main>
    </div>
  );
}